import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, ApplicationRef, OnChanges, NgZone, ElementRef, ViewChild, ViewChildren, QueryList, Directive } from '@angular/core';
import { Frame } from 'scenejs';
import { HttpClient } from '@angular/common/http';
import { DatePipe, KeyValue } from '@angular/common';
import { RouterModule, Routes, Router, ActivatedRoute, Params } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatSelectionList, MatSelectionListChange, MatListOption } from '@angular/material/list';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DevisFormComponent } from '../devis-form/devis-form.component';
import { NgxMoveableComponent } from "ngx-moveable";
import { fabric } from 'fabric';
import { Subscription, fromEvent } from 'rxjs';
import { User } from '../models/user';
import { SeoService } from 'projects/hp-api/src/lib/services/seo.service';
import { vueMaisonComponent } from '../dialogs/vue-maison/vue-maison.component';
import { SimulationAideComponent } from '../simulation-aide/simulation-aide.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'projects/hp-api/src/lib/services/user.service';
import { AuthentificationService } from "projects/hp-api/src/lib/services/authentification-service.service";
import Moveable from "moveable";
import domtoimage from 'dom-to-image';
import 'hammerjs';
import * as Hammer from 'hammerjs';

//HP
import { MenuSystemComponent } from "./menu-system/menu-system.component";
import { WizardQuestionsMenuComponent } from "./wizard-menu/wizard-questions-menu.component";
import { WizardAnswersMenuComponent } from "./wizard-menu/wizard-answers-menu.component";
import { WizardImageControllerComponent } from "./wizard-product-image/wizard-image-controller.component";
import { MobileMenuComponent } from "./mobile/menu/mobile-menu.component";
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { MatSidenav } from '@angular/material';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Platform } from '@angular/cdk/platform';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';
import { WizardExpansionMenuComponent } from './wizard-menu/wizard-expansion-menu.component';
import { InfosPrixComponent } from '../dialogs/infos-prix/infos-prix';
import { WizardHpModelFilterableBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-model-filterable-base-component';
import { WizardMultiMenuComponent } from './wizard-menu/wizard-multi-menu.component';
import { WizardAnswersMultiMenuComponent } from './wizard-menu/wizard-answers-multi-menu.component';
import { WizardNavCatalogComponent } from './wizard-menu/wizard-nav-catalog.component';
import { MaisonMobileComponent } from '../dialogs/vue-maison/maisons-mobile.component';
import { WizardInfosProduitComponent } from './wizard-menu/wizard-infos-produit.component';
import { WizardWindowsMenuComponent } from './wizard-menu/wizard-windows-menu.component';
import { ModalInfoComponent } from '../base/modal-info.component';
import { WizardStepMultiMenuComponent } from './wizard-menu/wizard-step-multi-menu.component';
import { WizardReglageComponent } from './menu-system/wizard-reglage.component';
//import { WizardImageIntControllerComponent } from './wizard-product-image/wizard-image-int-controller.component';
//declare function matomo(): void;

export interface Porte {

  id_marketing: number;
  enabled: number;
  type_porte: number;
  style: string;
  materiau: string;
  gamme: string;
  refp: string;
  name: string;
  couleur_principale: string;
  Typevitrage: number;
  id: number;
  formes: any[];
  image: string;
  image_random: string;
}

export interface Fenetre {
  id: number;
  type: number;
  name: string;
  refp: string;
  matieres: any;

}

const componentForm = {
  street_number: "short_name",
  route: "long_name",
  locality: "long_name",
  administrative_area_level_1: "short_name",
  country: "long_name",
  postal_code: "short_name",
};
const scrollToTop = () => {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, c - c / 8);
  }
};
declare var require: any
@Directive({ selector: 'ngx-moveable' })
class NgxMoveableDirective {
  updateRect: any;
}
@Component({
  selector: 'app-simulateur',
  templateUrl: './simulateur.component.html',
  styleUrls: ['../base/wizard/wizard-hp-base-component.scss', './simulateur.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  //host: {'class': 'app_simulateur'},
  animations: [
    trigger('slideInOut', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(-220%,0,0)'

      })),
      state('out', style({
        transform: 'translate3d(135px, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),

    trigger('slideInOutMobile', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(0,500%,0)'

      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),
    trigger('reglageSlideOut', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(0,500%,0)'

      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),
    trigger('slideInOutRigth', [
      state('in', style({
        transform: 'translate3d(200%,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideInOutForme', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(-240%,0,0)'

      })),
      state('out', style({
        transform: 'translate3d(135px, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ]),
    trigger('slideInOutWindowsAnswers', [
      state('in', style({
        display: 'none',
        transform: 'translate3d(-240%,0,0)'

      })),
      state('out', style({
        transform: 'translate3d(135px, 0, 0)',
        display: 'block'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('0ms ease-in-out'))
    ])
  ]
})

export class SimulateurComponent extends WizardHpModelFilterableBaseComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('swipeCanvas', { static: false }) swipeCanvas: ElementRef;
  @ViewChild('container', { read: ElementRef, static: true }) container: ElementRef;
  @ViewChild(MatSelectionList, { static: true })
  @ViewChild("moveableViewExt", { read: ElementRef, static: false }) moveableViewExt: NgxMoveableComponent;
  @ViewChild("target", { static: false }) target: NgxMoveableComponent;
  @ViewChild("multiTarget", { static: false }) multiTarget: NgxMoveableComponent;
  @ViewChild("mapTarget", { static: false }) mapTarget: NgxMoveableComponent;
  @ViewChildren("moveableProducts") moveableProducts!: QueryList<NgxMoveableDirective>;
  @ViewChild('canvas', { static: false }) canvas: ElementRef;
  @ViewChild('downloadLink', { static: false }) downloadLink: ElementRef;
  @ViewChild(MatSelectionList, { static: true }) vitrageDeporte: MatSelectionList;
  @ViewChild('MatSidenav', { static: false }) MatSidenav: ElementRef;
  @ViewChild('mainAppWizardQuestions', { static: false }) wizardQuestionsComponent: WizardQuestionsMenuComponent;
  @ViewChild('WizardExpansionMenuComponent', { static: false }) wizardExpansionMenuComponent: WizardExpansionMenuComponent;
  @ViewChild('wizardMultiExpansionMenuComponent', { static: false }) wizardMultiExpansionMenuComponent: WizardMultiMenuComponent;
  @ViewChild('wizardMultiMenuComponent', { static: false }) wizardMultiMenuComponent: WizardMultiMenuComponent;
  @ViewChild('mainAppWizardAnswers', { static: false }) wizardAnswersComponent: WizardAnswersMenuComponent;
  @ViewChild('mainAppWizardMultiAnswers', { static: false }) mainAppWizardMultiAnswers: WizardAnswersMultiMenuComponent;  
  @ViewChild('mainAppWizardImageController', { static: false }) wizardImageControllerComponent: WizardImageControllerComponent;
  @ViewChild('mainAppWizardImageController', { static: false }) wizardImageIntControllerComponent: WizardImageControllerComponent;
  @ViewChild('wizardNavCatalogComponent', { static: false }) wizardNavCatalogComponent: WizardNavCatalogComponent;
  @ViewChild('wizardInfosProduit', { static: false }) wizardInfosProduit: WizardInfosProduitComponent; 
  @ViewChild('wizardReglage', { static: false }) wizardReglage: WizardReglageComponent; 
  @ViewChild('mainAppWizardWindowsMenu', { static: false }) mainAppWizardWindowsMenu: WizardWindowsMenuComponent; 
  @ViewChild('mainAppWizardStepMultiMenu', { static: false }) mainAppWizardStepMultiMenu: WizardStepMultiMenuComponent; 
  @ViewChild("mainMobileMenu", { static: false }) mobileMenu: MobileMenuComponent;
  @ViewChild("mainMenuSystem", { static: false }) systemMenu: MenuSystemComponent;
 
  eventsSubject: Subject<void> = new Subject<void>();
  sidenav!: MatSidenav;
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  todayDate: Date;
  canvasExt: any;
  canvasInt: any;
  title = 'simuleo-app';
  clients: any; datas: any;
  infos: any;
  styleId: any;
  vue: string;
  indexElements: number;
  view: string; urlImg: string;
  isOk: boolean;
  elementCurrent: string; elementsLength: number;
  viewExt: string; viewInt: string;
  id_vitrage_type: number;
  scalable = true;
  resizeable = false;
  draggable = false;
  warpable = true;
  warpableInt = false;
  rotatableExt = false;
  mapResizable = false;
  mapDraggable = false;
  elementId: number;
  hasBorder = "hide-border"; tierceIndex = -1;
  formeId = 1;
  isUploadExt;
  isUploadInt;
  inReverseExt: boolean; inReverseInt: boolean;
  initView: string;
  btnWidth = 85;
  btnHeight = 18;
  btn: any; btn_int: any; domExt; domInt;
  showProperty = false;
  showProperty_int = false;
  showBtn_ok = false;
  controlShowed;
  targetElement; targetIntElement;
  targetBtn;
  counterUser;
  pdf_ok = false;
  nmbrePorte: number;
  viewMap = "0";
  id_colorInt: any;
  viewportTransform: any;
  viewportTransformInt: any;
  answers_variableId = [];
  answers_variableValues = [];
  answers_variable = [];
  answrs_type: any;
  idCouleurInt;
  idCouleurExt;
  couleurQstId;
  warpMatrix = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
  matrix3dTierce = [1.5, 0.00537634, 0, 1.29032e-20, -1.99295e-17, 1, 0, -4.43804e-19, 0, 0, 1, 0, 35.0001, 0.5, 0, 1];
  matrix3dDoubleT = [2.12945, 2.06476e-09, 0, 3.46945e-18, 1.35325e-17, 1, 0, -5.15975e-19, 0, 0, 1, 0, 76.0001, 1.56934e-07, 0, 1];
  matrix3dLarge = [1.26882, -9.86989e-10, 0, 8.38389e-32, 5.36792e-24, 1, 0, -2.1684e-19, 0, 0, 1, 0, 25, -9.17895e-08, 0, 1];
  starWrap = true;
  starWrapInt = true;
  objectExt_transform = true;
  objectInt_transform = true;
  visualType = "view-0";
  warpableProduct = false;
  warpable_product = false;
  warpable_index =-1;
  porteInt = [];
  porteExt = [];
  frameMap = new Frame({
    left: '0%',
    top: '0%',
    translate: [0, 0]
  });
  dataMap = {
    "visible": 0,
    "linkposition": "46.98123233164222,1.805750207787383",
    "heading": 108.76767031965346,
    "pitch": 2.8858925347222737,
    "fov": 159
  };
  warpableViewStreet = false;
  draggableViewStreet = false;
  frames = new Frame({
    left: '60%',
    top: '20%',
    transform: {
      rotate: '0deg',
      scaleX: 1,
      scaleY: 1,
      matrix3d: this.warpMatrix,
    },
  });
  frameInt = new Frame({
    left: '60%',
    top: '20%',
    transform: {
      rotate: '0deg',
      scaleX: 1,
      scaleY: 1,
      matrix3d: this.warpMatrix,
    },
  });

  productsFrames = [];
  productsTransform =[];
  product_element = -1;
  product_index = -1;
  createProductIndex = -1;
  transformCss_w =[];
  warpableProduct_active = false;
  menuState: string = 'in';
  menuRightState: string = 'in';
  menuFormeState: string = "in";
  menuModeleState: string = "in";
  menuAnswerState: string = 'in';
  multiMenuAnswerState :string ="in";
  menuAnswerStateMobile: string = 'in';
  menuQuestionStateMobile: string = "in";
  menuReglageStateMobile: string = "in";
  menuReglageRightState: string = 'in';
  menuReglageLeftState ="in";
  asideTabletState: string = "in";
  menuAnswersWindowsState: string ="in";
  menuAnswersStepMenuState: string ="in";
  simulateur: number;
  currentUser: User;
  currentUserSubscription: Subscription;
  profile: any;
  id_contact: any;
  isNow: any;
  lat = 45.015530;
  lng = -0.064945;
  placeSearch: google.maps.places.PlacesService;
  autocomplete: google.maps.places.Autocomplete;
  address: any;
  phone: any;
  formattedAddress: any;
  formattedaddress = " ";
  options = {
    componentRestrictions: {
      country: ["AU"]
    }
  }
  simulation_in = false;
  etape_show = false;
  mat_stepper_width = 198;
  step = -1;
  catalog: any;
  //is_loading = false;
  panelOpenState = false
  modelPanelOpenState = false;
  panelOpenMenuState = false;
  panneaux = [];
  searchControl = new FormControl();
  searchWindowControl = new FormControl();
  filteredOptions: Observable<Porte[]>;
  options_: Porte[] = [];
  type_index = -1;
  style_index = -1;
  jsonCanvasExt: any;
  modeleExt_back: any;
  idPorte_back: any;
  isChecked = false;
  viewChecked = false;
  formGroup: FormGroup;
  current_forme = 1;
  start_simuleo = false;
  visual_extSelected = "view";
  visual_intSelected = "view";
  index_porte: any;
  formesId = [];
  porteExtId: any;
  porteIntId: any;
  mobileTarget: number;
  /* Hammerjs*/
  managerExt: any;
  managerInt: any;
  imageExt = document.getElementById('imageExt');
  imageInt = document.getElementById('imageInt');
  previousPage = 0;
  object_catalog;
  hammer_active = false;
  paramsCss: any;
  width_forme = 186;
  couleur_1 = "";
  couleur_2 = "";
  porteDisplay: number;
  products: any;
  one_product: any;
  liste_rep: any;
  catId: any;
  //prodId: any;
  famId: any;
  product: any;
  wPorte!: number;
  hPorte!: number;
  hauteurValue: number;
  largeurValue: number;
  answers: any;
  product_answers :any;
  questions: any;
  questionSelected: any;
  question_code: any;
  currentCode: any;
  keySelected: any;
  answer_index: any;
  answerProgress = false;
  currentElement_type;
  currentMultiElement_type:any =[];
  produits: any;
  isMobile = false;
  transformCss = [];
  dataResult = [];
  base64String: any;
  mc: any;
  fileUpload_photo = "";
  config: any;
  configurationHerculePro: any;
  target_area_index = 0;
  target_area_selected = true;
  target_area_center = "area-center";
  forme_selected = "simple";
  bottomMenu: string;
  mobileTargetInt: number;
  classNameAnswer_side = "answer-side";
  questionTitleAnswers: any;
  questionTitleAnswersProduct:any;
  hammerScale = 1;
  isExterior = true;
  viewExt_int = "0";
  default_color: any;
  default_poignee: any;
  currentGrpId: any;
  currentQstId: any;
  qstKeywords: any;
  mapPicter: any;
 showMultiProduct = false;
 productsGlobalDtata :any = [];
 multiGlobaldata:any;
 catalog_index:any;
 list_catalog:any =[];
 previousPageLapel = "famille";
 menuBottom_active = "no-menu-active";
 switchViewClicked = 0;
 catalog_selected:any = 0;
 stateDetail:string ="in";
 menu_selected = 0;
 shareBtn = false;
 menu_standard = true;
 showProduct_visua_menu = true;
 currentIndex = 0;
 createLoading = false;
 element_showed = -1;
 currentRefWidows="";
 config_libelle:any;
 menuImage = false;
dialogVue_active = false;
isForceMultiViews = false;
hasInOrOutView = false;
list_catalogLoaded:any;
isLoading = false;
redimMsg_dialog = false;
current_question ={};
currentMenuProductStep : string;
isFlippedHorizontallyMulti = [];
globalDataLength = 0;
simulateurActive = false;
switchViewLoading = false;
isMultiProduct = false;
proprieteCss:any
bounds: any = {"left":0,"top":0,"right":0,"bottom":0,"position":"css"};
  ngOnChanges() {

  }

  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService,
    formBuilder: FormBuilder,
    private userService: UserService, private authentificationService: AuthentificationService,
    private seo: SeoService,
    private el: ElementRef,
    private http: HttpClient,
    private route: ActivatedRoute,
    router: Router,
    public zone: NgZone,
    private platform: Platform,
    public dialog: MatDialog, private datePipe: DatePipe, 
    private deviceService: DeviceDetectorService,
    private observer: BreakpointObserver) {
    super(chgDetectorRef, hpService, router);
  
    this.getHpService().emitDataChange();
    this.getHpService().setHeaderIn(true);
    this.productsFrames = this.getHpService().getproductsFrames();
  //  this.transformCss_w= this.getHpService().gettransformCss_w();
    this.getHpService().setCurrentPage(this.getIndexNextUrl('simulateur-de-portes'))
    if (!this.getHpService().currentProductValue) {
      this.getRouter().navigate([this.getHpService().getConfig().herculepro.slug]);
    }
    this.fileUpload_photo = this.getHpService().getUrl_ambiance() + "/ambiances/plgnd-sample-207.jpg";
    this.view = this.getHpService().getView() === '0' ? '0' : '1';
    this.initView = this.getHpService().getView() === '0' ? '0' : '1';

   
    this.object_catalog = this.getHpService().getProduct();
    this.simulateur = 1; //this.getHpService().getProduct() === "porte" ? 1 : 2;
    this.product = this.getHpService().getGlobaldata();
    this.hauteurValue = this.getHpService().getHeight();
    this.largeurValue = this.getHpService().getWidth();
   // this.transformCss = this.getHpService().getTransformCss();
    this.produits = this.getHpService().getListProducts();
    this.previousPage = this.getHpService().getPreviousPage();
    this.formesId = [];
    this.simulateurActive = this.getHpService().getSimulateurActive();
    this.getHpService().clearOptionSelected();
    this.isMultiProduct = this.getHpService().getConfig().herculepro.multiProduct;
    
    if(this.getHpService().getListCalogLoaded().length === 0  && this.getHpService().getConfig().herculepro.multiProduct )
      {
        let catalog = {"catalog":this.getHpService().getListCataglog()[0], "navCat_index":0,"produc_index":0 };
        this.list_catalog.push(catalog); 
        this.getHpService().setListCatalog(catalog);
        
      }
      else
      {
        this.list_catalog = this.getHpService().getListCalogLoaded();
      
      }
      if(!this.simulateurActive)
      {
        this.initDefaultProduct();
      }
      
      this.multiGlobaldata = this.getHpService().getMultiGlobaldata();
      this.config_libelle = this.getHpService().getConfig().content_page;
      if(this.getHpService().getConfig().herculepro.slug !== "caseo")
      {
        this.switchViewClicked = 1;
      }
      if (this.getHpService().getEtape_final()) {
        this.isExterior = (this.view === '0') ? true : false;
        this.viewExt_int = this.view;
        this.visualType = "view-" + this.view;
        this.getHpService().setTypeVisuel("view-" + this.view);         
      }
    
  }

  ngOnInit() {
    super.ngOnInit();
    this.previousPageLapel = this.getIndexNextUrl('dimensions') > -1 ? "dimensions" : this.previousPageLapel;
    this.observer.observe(['(max-width: 665px)']).subscribe((res) => {
      if (res.matches) {
        this.isMobile = true;
        scrollToTop();
      }
    });
    this.observer.observe(['(max-width: 800px)']).subscribe((res) => {
      if (res.matches) {
          scrollToTop();
      }
    });

   
   
 if(this.getHpService().getshowMenuWindows())
    {
      this.product_answers = this.getHpService().getProduct_answers();
      this.menu_selected = this.getHpService().getCatalogIndex();
      this.showProduct_visua_menu = false; 
      this.createLoading = true;
      this.currentMenuProductStep = "OUVERTURE";
      this.getHpService().setBooleanParam("standard-menu-answer",false);
      let catalog = {"catalog":this.getHpService().getListCataglog()[1], 
        "navCat_index":this.menu_selected,"produc_index":1 }
       this.setShowMultiproduct(true);
       this.addObject(false,1);
       this.catalog_index = 1;
       this.list_catalog.push(catalog);
       this.getHpService().setListCatalog(catalog);
       this.toggleMenu('aside-menu-expansion-windows');
       
    }  
      
   
  }


  
  ngOnDestroy(): void {

  }



  
  ngAfterViewInit(): void {
    this.initHammerjs(false);
    this.hammer_active = false;
   // this.transformCss.push("rotate(0deg) scaleX(1) scaleY(1) matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)");
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    
    if (this.platform.IOS || this.platform.ANDROID) {
      console.log('this is IOS device! /android');
      this.hammerScale = 2;
      this.initPorteHammerjs();
    }
    this.porteExtId = document.getElementById('target') as HTMLInputElement;
    this.starWrap = (this.getHpService().getCssTargetInt()) ? true : false;
    this.starWrapInt = (this.getHpService().getCssTargetInt()) ? true : false;

    if (this.getHpService().getEtape_final()) {

      this.closeMenu();
      this.transformCss = this.getHpService().getTransformCss();
      this.frames = this.getHpService().getFramesExt();
      this.frameInt = this.getHpService().getFramesInt()
      let porteElement = document.querySelector(".target");
      this.setTransform(porteElement);
      if (this.wizardImageControllerComponent) {
        this.wizardImageControllerComponent.updateImagesRect();
      }

      this.inReverseInt = this.getHpService().getInReverse('1');
      this.inReverseExt = this.getHpService().getInReverse('0');     
     
    }
    this.warpable = false;
    this.warpableInt = false;
    this.simulation_in = this.getHpService().getStatut_user();

    let map_in = this.getHpService().getDataMap();
    this.dataMap = (map_in.visible === 1) ? map_in : this.dataMap;
    this.mapPicter = "https://maps.googleapis.com/maps/api/streetview?size=640x360&location=" +
      this.dataMap.linkposition + "&heading=" + this.dataMap.heading + "&fov=" +
      this.dataMap.fov + "&pitch=" + this.dataMap.pitch + "&key=" + this.getHpService().getConfig().data_googleMap.key;
    this.visual_extSelected = (map_in.visible === 1) ? 'googleMap' : "view-" + this.getHpService().getView();
    this.visualType = this.getHpService().getTypeVisuel(this.getHpService().getView());
    setTimeout(() => {
      this.etape_show = true;
      this.mat_stepper_width = this.mat_stepper_width + 142;
    }, 1000);

    this.controlShowed = true;
    this.targetElement = document.getElementById("target") as  HTMLInputElement;
    this.targetBtn = document.getElementById("back-btn");
    this.btn = document.getElementById('inline-btn-ext');
    this.btn_int = document.getElementById('inline-btn-int');

    this.domExt = document.getElementById('canvasExt');
    this.domInt = document.getElementById('canvasInt');
    this.elementId = 1;
    this.indexElements = 0;
    this.viewExt = this.getHpService().getImageName('0');
    this.viewInt = this.getHpService().getImageName('1');
    this.isUploadExt = this.getHpService().getIsUploadExt(this.getHpService().getView());
    this.isUploadInt = this.getHpService().getIsUploadExt(this.getHpService().getView());
    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.cornerStyle = 'circle';
    fabric.Object.prototype.cornerSize = 25;
    fabric.Object.prototype.cornerColor = this.getHpService().getConfig().default_couleur;
    fabric.Object.prototype.borderColor = this.getHpService().getConfig().default_couleur;
    fabric.Object.prototype.rotatingPointOffset = 30;
    fabric.Object.prototype.originX = fabric.Object.prototype.originY = 'center';

    this.canvasExt = new fabric.Canvas("canvasExt", {
      selection: false,
      selectionBorderColor: '#f48221',
      backgroundColor:'#111111',
      centeredScaling: true,
      controlsAboveOverlay: true,
      allowTouchScrolling: true

    });
    this.initOneCanvas(this.canvasExt);

    this.canvasInt = new fabric.Canvas("canvasInt", {
      centeredScaling: true,
      selection: false,
      backgroundColor: '#F8F5F3',
      selectionBorderColor: '#f48221',
      controlsAboveOverlay: true,
      allowTouchScrolling: true
    });
    this.initOneCanvas(this.canvasInt);

    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
      this.onSimulateurResize();
    });

    if (this.sidenav) {
      this.observer.observe(['(max-width: 800px)']).subscribe((res) => {
        if (res.matches) {

          this.sidenav.mode = 'over';
          this.sidenav.close();


        } else {
          this.sidenav.mode = 'side';
          this.sidenav.open();

        }
      });
    }
    if (this.getHpService().getStatut_user() && this.getHpService().getConfig().content_page.simulateur.aide_video_in) {
      this.openAide("selecteur");
    }   
    if(this.getHpService().getshowMenuWindows())
      {
        this.hiddenElement(0); 
    
      } 
    if(!this.simulateurActive)
      {
        this.initWithoutProduct(); 
      }   
    if(!this.isMultiProduct)
      {
        this.getHpService().removeProducts(0);
      }  
      
    this.wizardImageControllerComponent.updateImagesRect();
    this.getHpService().emitDataChange();
  }

  onSimulateurResize() {
    this.initOneCanvas(this.canvasExt);
    this.initOneCanvas(this.canvasInt);
    this.wizardImageControllerComponent.updateImagesRect();
    if (window.innerWidth < 668) {
      this.width_forme = 130;
    }
  }

  initOneCanvas(canvas: any) {

    canvas.setWidth(this.container.nativeElement.offsetWidth + 15);
    canvas.setHeight(this.container.nativeElement.offsetHeight);
    canvas["counter"] = 0;
    canvas["cornerStyle"] = 'circle';
    canvas.cornerSize = 25;
    canvas.cornerColor = this.getHpService().getConfig().default_couleur;
    canvas.borderColor = this.getHpService().getConfig().default_couleur;
    canvas.backgroundColor = "#000";
    canvas.originX = 'center';
    canvas.selection = false;
    let scale_X = 1; let scale_Y = 1;
    if (canvas.width <= 1366) {
      scale_X = 0.7;
      scale_Y = 0.7;
    }

    fabric.util.loadImage(this.setImageViewExt(), (img) => {

      let imgInstance = new fabric.Image(img);
      let ratio = this.calcImageSize(imgInstance.width, imgInstance.height).ratio;
      imgInstance.set({
        hasControls: false,
        hasBorders: false,
        evented: false,
        scaleY: ratio,
        scaleX: ratio,
        originX: 'center',
        originY: 'center',
      });
      canvas.clear();
      canvas.add(imgInstance);
      canvas.calcOffset()
      canvas.centerObject(imgInstance);
      canvas.setActiveObject(imgInstance);
      canvas.renderAll();
      //  this.endResizeImage();
      imgInstance.on('moving', () => { this.positionBtn(imgInstance) });
      imgInstance.on('scaling', () => { this.positionBtn(imgInstance) });
      this.viewportTransform = imgInstance.getViewportTransform();
      this.positionBtn(imgInstance);

    });
    canvas.on('mouse:down', () => {
      this.hideMoveableControler();
      this.hideBorder();
      this.hideElementBorder();
    });
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  getIsLoading() {
    return this.getHpService().getIsLoading();
  }

  getMultiIsLoading() {
    return this.getHpService().getIsLoading();
  }

  openDialog(demande: string) {
    this.warpable = false;

    const dialogRef = this.dialog.open(DevisFormComponent, {
      panelClass: 'full-width-dialog-devis',
      data: { name: demande }
    });
    this.setElementCurrent('hidden');
    this.menuRightState = "in";
    this.menuState = "in"
    this.menuQuestionStateMobile = "in";
    this.menuReglageStateMobile = "in";
    this.asideTabletState = "in";
    this.menuAnswersWindowsState = "in";
    dialogRef.afterClosed().subscribe(result => {

    });

  }

  public getSimulateur() {
    return this;
  }

  getVisualExtSelected() {
    return this.visual_extSelected;
  }

  openVueMaison(vue: string) {

    this.closeAllMenu();
    this.closeMsg();
    this.warpable = false;
    this.showProperty = false;
    this.dialogVue_active = true;
    this.menuImage = false;
    this.getHpService().emitDataChange();
    if (this.isExterior) {
      this.getHpService().setView("0");
    }
    else {
      this.getHpService().setView("1");
    }
    this.view = vue;
   // let componentDialog = (this.isMobile) ?  MaisonMobileComponent : MaisonsComponent;
    const dialogRef = (this.isMobile) ? this.dialog.open(MaisonMobileComponent, {
      panelClass: 'full-width-dialog-vue-maison',
      data: { vue: vue, visual: this.visual_extSelected }
    }) : this.dialog.open(vueMaisonComponent, {
      panelClass: 'full-width-dialog-vue-maison',
      data: { vue: vue, visual: this.visual_extSelected }
    });
    this.setElementCurrent('hidden');
    this.menuRightState = "in";
    this.menuState = "in";
    this.menuQuestionStateMobile = "in";
    this.menuReglageStateMobile = "in";
    this.asideTabletState = "in";
    this.menuAnswersWindowsState = "in";
    let me = this;
    dialogRef.afterClosed().subscribe(result => {
    this.getHpService().emitDataChange();
    if(this.getHpService().getConfig().herculepro.multiProduct)
    {
      
    this.warpableProduct =true;
    }
    else
    {
       this.warpable = true;
    }
   
      if (result) {
        switch (this.getHpService().getView()) {
          case '0':
       
            this.visual_extSelected = (result.length > 0) ? result[0].type : this.getHpService().getTypeVisuel(vue);
            this.visualType = (result.length > 0) ? result[0].type : this.getHpService().getTypeVisuel(vue);
            this.getHpService().setIsUploadExt(result[0].type === "upload-0");
            let imageName = (this.visualType  === "googleMap" && this.getHpService().getView() === '0') ?
            this.getHpService().getImageName(this.getHpService().getView()) : result[0].data;
            this.getHpService().setImageName(imageName);
            this.getHpService().setTypeVisuel(result[0].type);
            this.getViewValue(imageName);
            this.getHpService().emitDataChange();   
            this.getChangeDetectorMultiRef().detectChanges();      

            break;
          case '1':
            this.visual_extSelected = (result.length > 0) ? result[0].type : this.getHpService().getTypeVisuel(vue);
            this.getHpService().setIsUploadInt(result[0].type === "upload-1");
            let imageNameInt = result[0].data;
            this.getHpService().setImageName(imageNameInt);
            this.viewInt = this.getHpService().getImageName(this.getHpService().getView());
            this.getHpService().setTypeVisuel(result[0].type);
            this.visualType = result[0].type;
            this.getViewValue(imageNameInt);
            this.getHpService().emitDataChange();
            this.getChangeDetectorMultiRef().detectChanges();
            break;
        }
        this.dataMap = (result[0].type === "googleMap" && vue === "0") ? this.getHpService().getDataMap() : this.dataMap;
      
      }
      this.dialogVue_active = false;
      this.menuImage = false;
      this.menuBottom_active = "no-menu-active";
      this.getHpService().emitDataChange();
    this.getChangeDetectorMultiRef().detectChanges();
    });
    this.getHpService().emitDataChange();
   this.getChangeDetectorMultiRef().detectChanges();


  }


  openAide(via: string) {
    this.closeAllMenu();
    this.getHpService().setStatut_user(false);
    this.menuBottom_active = "menu-aide";
    this.menuImage = false;
    this.warpableProduct =false;
    this.warpable = false;
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges()
    const dialogRef = this.dialog.open(SimulationAideComponent, {
      panelClass: 'full-width-dialog-aide',
      data: { via: via }
    });
    this.setElementCurrent('hidden');
    this.closeAllMenu();
    let me =this
    dialogRef.afterClosed().subscribe(result => {
       me.menuBottom_active = "no-menu-active";
      this.getChangeDetectorRef().detectChanges()
    });

  }

  closeDialog() {
   this.dialog.closeAll();
   this.menuBottom_active = "no-menu-active";
   this.warpable = true;
  // this.closeResizeImage();
   this.menuImage = false;
}

  openInfosPrice(via: string) {
    this.closeAllMenu();
    this.getHpService().setStatut_user(false);
    const dialogRef = this.dialog.open(InfosPrixComponent, {
      panelClass: 'full-width-dialog-info-price',
      data: { via: via }
    });
    this.setElementCurrent('hidden');
    dialogRef.afterClosed().subscribe(result => {
    });

  }

  /*
  **Functions Porte
  */
  trackElementId(id: number, id_current: number) {
    return id === id_current;
  }

  getClasses(id, id_current): string {
    return id === id_current ? "item-showed" : "item-hidden";
  }
  setClassActive(bool): string {
    return bool ? "item-active" : "item-inactive";
  }

  getRgb(rgb_: string) {
    return {
      background: (rgb_ === undefined) ? 'transparent' : "#" + rgb_
    };
  }

  setTab(name, id) {

    switch (name) {

      case 'vitrage':
        this.id_vitrage_type = id;
        break;
    }
  }

  setActive(bool): string {
    return bool ? "item-active" : "item-inactive";
  }



  getClasseVitrages(id, id_current, inAllelement): string {
    return (id === id_current) && inAllelement ? "item-showed" : "item-hidden";
  }

  /*
  FabricJs functions
  */

  positionBtn(obj) {


  }

  getAbsoluteCoords(object) {
    return {
      left: object.left,
      top: object.top
    }
  }

  observeBoolean() {

   
    if(this.visual_extSelected === 'googleMap' && this.isMobile)
    {
      this.redimMsg_dialog = true
      return;
    }
    this.menuRightState = "in";
    this.menuState = "in"
    this.menuQuestionStateMobile = "in";
    this.menuReglageStateMobile = "in";
    this.closeAllMenu();
    this.showBtn_ok = true;
    this.menuImage = false;
    this.porteExtId.style.display = "none";
    this.canvasExt.clear();
    this.warpable = false
    this.showProperty = true;
    fabric.util.loadImage(this.setImageViewExt(), (img) => {
      let imgInstance = new fabric.Image(img);
      let ratio = this.calcImageSize(imgInstance.width, imgInstance.height).ratio;
      imgInstance.set({
        hasControls: true,
        hasBorders: true,
        evented: true,
        scaleY: ratio / 2,
        scaleX: ratio / 2,
        originX: 'center',
        originY: 'center',

      });
      this.canvasExt.clear();
      this.canvasExt.add(imgInstance);
      this.canvasExt.calcOffset()
      this.canvasExt.centerObject(imgInstance);
      this.canvasExt.setActiveObject(imgInstance);
      this.canvasExt.renderAll();
    });

    this.canvasExt.renderAll();
    

  };

  endResizeImage() {
    this.showBtn_ok = false;
    this.warpableViewStreet = false;
    this.draggableViewStreet = false;
    this.mapResizable = false;
    this.mapDraggable = false;
    this.menuImage = true;
    let porte_ext = document.getElementById('target') as HTMLElement;
    let porte_int = (this.isExterior) ? document.getElementById('target') as HTMLElement : document.getElementById('targetInt') as HTMLElement;

    this.porteExtId.style.display = "block";
    this.showProperty = false;
    this.canvasExt.getActiveObject().hasControls = false;
    this.canvasExt.getActiveObject().evented = false;
    this.canvasExt.renderAll();

    if (this.isExterior) {
      let coord =
      {
        "width": this.canvasExt.getActiveObject().width,
        "height": this.canvasExt.getActiveObject().height,
        "top": this.canvasExt.getActiveObject().top,
        "left": this.canvasExt.getActiveObject().left,
        "scaleX": this.canvasExt.getActiveObject().scaleX,
        "scaleY": this.canvasExt.getActiveObject().scaleY
      }
      this.getHpService().setImageCanvasExt(coord);

    }
    else {
      let coord =
      {
        "width": this.canvasExt.getActiveObject().width,
        "height": this.canvasExt.getActiveObject().height,
        "top": this.canvasExt.getActiveObject().top,
        "left": this.canvasExt.getActiveObject().left,
        "scaleX": this.canvasExt.getActiveObject().scaleX,
        "scaleY": this.canvasExt.getActiveObject().scaleY
      }
      this.getHpService().setImageCanvasInt(coord);
    }

  this.menuImage = false;
  this.menuBottom_active = "no-menu-active";
  if(this.getHpService().getConfig().herculepro.multiProduct)
    {
      this.warpableProduct =true;
    }
  else
    {
    this.warpable = true;
    }
  this.getHpService().emitDataChange();
  this.getChangeDetectorRef().detectChanges();
  //this.menuImage= true;
 
  };

  setDimensionImage() {

    if (this.getHpService().getImageCanvasExt() && this.isExterior) {

      this.canvasExt.clear();
      this.warpable = false
      this.showProperty = false;
      fabric.util.loadImage(this.setImageViewExt(), (img) => {
        let imgInstance = new fabric.Image(img);
        imgInstance.set({
          hasControls: false,
          hasBorders: false,
          evented: false,
          width: this.getHpService().getImageCanvasExt().width,
          height: this.getHpService().getImageCanvasExt().height,
          top: this.getHpService().getImageCanvasExt().top,
          left: this.getHpService().getImageCanvasExt().left,
          scaleX: this.getHpService().getImageCanvasExt().scaleX,
          scaleY: this.getHpService().getImageCanvasExt().scaleY
        });
        this.canvasExt.clear();
        this.canvasExt.add(imgInstance);
        this.canvasExt.setActiveObject(imgInstance);
        this.canvasExt.renderAll();


      });

      this.canvasExt.renderAll();
    }
    if (this.getHpService().getImageCanvasInt() && !this.isExterior) {
      this.canvasExt.clear();
      this.warpable = false
      this.showProperty = false;
      fabric.util.loadImage(this.setImageViewInt(), (img) => {
        let imgInstance = new fabric.Image(img);
        imgInstance.set({
          hasControls: false,
          hasBorders: false,
          evented: false,
          width: this.getHpService().getImageCanvasInt().width,
          height: this.getHpService().getImageCanvasInt().height,
          top: this.getHpService().getImageCanvasInt().top,
          left: this.getHpService().getImageCanvasInt().left,
          scaleX: this.getHpService().getImageCanvasInt().scaleX,
          scaleY: this.getHpService().getImageCanvasInt().scaleY
        });
        this.canvasExt.clear();
        this.canvasExt.add(imgInstance);
        this.canvasExt.setActiveObject(imgInstance);
        this.canvasExt.renderAll();


      });
      this.canvasExt.renderAll();
    }
  }

  closeResizeImage() {
    this.initView = '1';
    this.showBtn_ok = false;
    this.warpableViewStreet = false;
    this.draggableViewStreet = false;
      if (this.isExterior) {

     
       this.wizardImageControllerComponent.updateMapImagesRect();
      this.porteExtId.style.display = "block";
      this.showProperty = false;
      this.canvasExt['hasControls'] = false;
      this.canvasExt['hasBorders'] = false;
      this.canvasExt['evented'] = false;

      this.canvasExt.clear();
      fabric.util.loadImage(this.setImageViewExt(), (img) => {
        let imgInstance = new fabric.Image(img);
        let ratio = this.calcImageSize(imgInstance.width, imgInstance.height).ratio;
        imgInstance.set({
          hasControls: false,
          hasBorders: false,
          evented: false,
          scaleY: ratio,
          scaleX: ratio,
          originX: 'center',
          originY: 'center',



        });
        this.canvasExt.clear();
        this.canvasExt.add(imgInstance);
        this.canvasExt.calcOffset()
        this.canvasExt.centerObject(imgInstance);
        this.canvasExt.setActiveObject(imgInstance);
        this.canvasExt.renderAll();
        this.endResizeImage();

      });

    }
    else {
      this.showProperty_int = false;
      this.canvasInt['hasControls'] = false;
      this.canvasInt['hasBorders'] = false;
      this.canvasInt['evented'] = false;
      this.canvasInt.clear();
      fabric.util.loadImage(this.setImageViewInt(), (img) => {
        let imgInstance = new fabric.Image(img);
        let ratio = this.calcImageSize(imgInstance.width, imgInstance.height).ratio;
        imgInstance.set({
          hasControls: false,
          hasBorders: false,
          evented: false,
          scaleY: ratio,
          scaleX: ratio,
          originX: 'center',
          originY: 'center',


        });
        this.canvasInt.clear();
        this.canvasInt.add(imgInstance);
        this.canvasInt.calcOffset()
        this.canvasInt.centerObject(imgInstance);
        this.canvasInt.setActiveObject(imgInstance);
        this.canvasInt.renderAll();
        this.endResizeImage();
      });
    }
    if(this.getHpService().getConfig().herculepro.multiProduct)
      {
        this.warpableProduct =true;
      }
    else
      {
      this.warpable = true;
      }

  };

closeMsg()
{
  this.redimMsg_dialog = false;
  if(this.getHpService().getConfig().herculepro.multiProduct)
    {
      this.warpableProduct =true;
    }
  else
    {
    this.warpable = true;
    }

}
  /*
  Transform Moveable Function Porte out
  */
  onDrag({ target, top, left }) {
  
    this.desactiveHammerjs();
    this.disableChildRefresh();
    this.wizardImageControllerComponent.updateImagesRect();

    if (this.isExterior) {
      this.frames.set('left', `${left}px`);
      this.frames.set('top', `${top}px`);
      this.setTransform(target);
     

    }
    else {
      this.frameInt.set('left', `${left}px`);
      this.frameInt.set('top', `${top}px`);
      this.setTransform(target);
    
    }


  }

  onDragEnd({ target }) {
    this.hammer_active = false;
    this.desactiveHammerjs();
    this.enableChildRefresh();
    this.wizardImageControllerComponent.updateImagesRect();
    let paramsCss =
    {
      "left": target.style.left,
      "top": target.style.top,
      "transform": target.style.transform
    }
    console.log(target.style.transform);
    this.proprieteCss = target.style.transform;
    this.getHpService().setCssTarget(paramsCss);
    this.starWrap = false;
    this.showMoveableControl();
  }


  onWarpStart(e) {

    this.wizardImageControllerComponent.updateImagesRect();
    this.hammer_active = false;
    this.desactiveHammerjs();
    if (this.isExterior) {
      e.set(this.frames);
    }
    else {
      e.set(this.frameInt);
    }
  }

  onWarp({ target, delta, multiply, clientX, clientY }) {
    this.wizardImageControllerComponent.updateImagesRect();
    if (this.isExterior) {
      this.frames.set('transform', 'matrix3d', multiply(this.frames.get('transform', 'matrix3d'), delta));
      this.setTransform(target);
      this.targetElement.style.opacity = "0.8";
    }
    else {
      this.frameInt.set('transform', 'matrix3d', multiply(this.frameInt.get('transform', 'matrix3d'), delta));
      this.setTransform(target);
      this.targetElement.style.opacity = "0.8";
    }
  }
  onWarpEnd({ target, isDrag, clientX, clientY }) {
    if (this.isExterior) {
      let paramsCss =
      {
        "left": target.style.left,
        "top": target.style.top,
        "transform": target.style.transform
      }
      this.getHpService().setCssTarget(paramsCss)
      this.transformCss[0] = target.style.transform;
    }
    else {
      let paramsCss =
      {
        "left": target.style.left,
        "top": target.style.top,
        "transform": target.style.transform
      }
      this.getHpService().setCssTargetInt(paramsCss)
      this.transformCss[0] = target.style.transform;
    }
    this.targetElement.style.opacity = "1";
    this.starWrap = false;
    this.objectExt_transform = false;

  }

  onPinchStart({ target }) {
    this.hammer_active = false;
    this.desactiveHammerjs();
    this.enableChildRefresh();
    this.wizardImageControllerComponent.updateImagesRect();
    target.style.cssText += target.cssText;
    this.showMoveableControl();
  }

  setTransform(target) {
    if (this.isExterior) {
      target.style.cssText = this.frames.toCSS();
      return;

    }

    target.style.cssText = this.frameInt.toCSS();
  }


  targetUpdateRect() {
    //this.moveableInt.updateRect();
    this.wizardImageControllerComponent.updateImagesRect();

  }

  setTransformInt(target) {
    target.style.cssText = this.frameInt.toCSS();
  }
  /*
  Transform Moveable Function Photo ext int
  */
  hideMoveableControler() {
    this.warpable = false && this.controlShowed;
    this.warpableInt = false;
    this.warpable_product = false;
     this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
    
   }

  public getIsWarpable() {

    if (this.isExterior) {
      return this.warpable;
    }
    return this.warpableInt;

  }

  public getIsControlShowed() {
    return this.controlShowed;
  }

  /**
   Transform Moveable Function Multi Product
  **/
   onBound(e) {
    console.log(e);

   }
     
   onDragProduct({target, top, left,clientX, clientY },i) {
   
    this.desactiveHammerjs();
    this.disableChildRefresh();
    this.setCurrentProductIndex(i);
    this.wizardImageControllerComponent.updateProductReact();
    if(this.isExterior){ 
    this.getHpService().getproductsFrames()[this.currentIndex].set('left', `${left}px`);
    this.productsFrames[this.currentIndex].set('top', `${top}px`);
    }
    else {
      this.frameInt.set('left', `${left}px`);
      this.frameInt.set('top', `${top}px`);
      this.setTransformProduct(target);
      this.targetElement.style.opacity = "0.8";
      this.getHpService().emitDataChange();
      this.getChangeDetectorRef().detectChanges();

    }
     }
   onDragEndProduct({target}){
    this.desactiveHammerjs();
    this.disableChildRefresh();
    this.wizardImageControllerComponent.updateProductReact();
    if(this.isExterior){
      return;
    }
    else {
      let paramsCss =
      {
        "left": target.style.left,
        "top": target.style.top,
        "transform": target.style.transform
      }
      this.getHpService().setCssTargetInt(paramsCss);
      this.getHpService().emitDataChange();
      this.getChangeDetectorRef().detectChanges();
    }
   }
  onWarpProduct({ target, delta, multiply,clientX, clientY },i) {
    if(this.isExterior) {
    this.productsFrames[this.currentIndex].set('transform', 'matrix3d', multiply(this.productsFrames[this.currentIndex].get('transform', 'matrix3d'), delta));
    this.setTransformProduct(target);
    this.setCurrentProductIndex(i);
    }
    else {
      this.frameInt.set('transform', 'matrix3d', multiply(this.frameInt.get('transform', 'matrix3d'), delta));
      this.setTransform(target);
      this.targetElement.style.opacity = "0.8";
    }
  }
  onWarpEndProduct({target, isDrag, clientX, clientY }) {
    this.desactiveHammerjs();
    this.disableChildRefresh();
    this.wizardImageControllerComponent.updateProductReact();
    if(this.isExterior) {
    this.paramsCss =
    {
     "left":target.style.left,
     "top": target.style.top,
     "transform": target.style.transform
    }
    this.transformCss_w[this.currentIndex]= target.style.transform;
    this.getHpService().updateObjecttransformCss_w(target.style.transform);
    this.targetElement.style.opacity = "1";
    this.starWrap = false;
    this.objectExt_transform = false;
  }
    else {
      let paramsCss =
      {
        "left": target.style.left,
        "top": target.style.top,
        "transform": target.style.transform
      }
      this.getHpService().setCssTargetInt(paramsCss);
      this.getHpService().emitDataChange();
      this.getChangeDetectorMultiRef().detectChanges();
      
    }
    // this.targetElement.style.opacity = "1";
   this.wizardImageControllerComponent.updateProductReact();
  }
  
  setTransformProduct(target) {
    if (this.isExterior) {
    this.getHpService().setproductsFrames(this.productsFrames); 
    let eleme_current = document.getElementById('target_product' + this.currentIndex) as HTMLInputElement;
    eleme_current.style.cssText = this.productsFrames[this.currentIndex].toCSS();
    this.productsTransform[this.currentIndex] = eleme_current.style.cssText;
    this.wizardImageControllerComponent.updateProductReact();
    this.getChangeDetectorMultiRef().detectChanges();
    this.getHpService().emitDataChange();
      return;

    }

    target.style.cssText = this.frameInt.toCSS();
  
  }
setCurrentElement(element)
{

  this.product_element = element;
  this.currentIndex = element;
}

SetProductFrame()
{
  let frame = new Frame({
    left: '40%',
    top: '40%',
    transform: {
      rotate: '0deg',
      scaleX: 1,
      scaleY: 1,
      matrix3d: this.warpMatrix ,
    }
  
  });
}
 showMoveableControl() {

    this.menuState = "in";
    this.showMultiProduct = false
    this.menuQuestionStateMobile = "in";
    this.menuReglageStateMobile = "in";
    this.asideTabletState = "in";
    this.elementCurrent = "";
    this.menuAnswersWindowsState = "in";
    this.modelPanelOpenState = false;
    this.warpable = true;
    this.warpable_product = false;
    this.warpable_index = -1;
    this.getHpService().emitDataChange();
  }


  getImage() {
    return this.getHpService().getImage();;
  }
  /*

  */
  updateImage() {
    this.urlImg = this.getHpService().getImage();
  }

  updateImg() {

    switch (this.view) {
      case '1':
        return this.getHpService().getIntImage();
        break;
      default:
        return this.getHpService().getImage();
    }

  }

  swipeHandler() { alert('Swipe handled!'); }

  calcImageSize(imgWidth, imgHeight) {
    let _imgWidth = imgWidth,
      _imgHeight = imgHeight;

    let ratio = 1, ratio1 = 1, ratio2 = 1;
    ratio1 = (this.getHpService().getView() === "0") ? this.canvasExt.width / _imgWidth : this.canvasExt.width / _imgWidth;
    ratio2 = (this.getHpService().getView() === "0") ? this.canvasExt.height / _imgHeight : this.canvasExt.height / _imgHeight;

    if (ratio1 < ratio2) {
      ratio = ratio1;
    }
    else {
      ratio = ratio2;
    }
    let returnObj = {
      "ratio": ratio

    };

    return returnObj;
  }
  /*
  ** String get id visual  has emmited by child
  */
  getViewValue(vue) {
   //this.isExterior =(vue === "0") ? true :false;
    this.getHpService().setView(this.isExterior ? "0" : "1");
    this.getHpService().emitDataChange()
    console.log(this.isExterior + ">getValu> "+this.getHpService().getView());
    this.viewExt = this.getHpService().getImageName(this.getHpService().getView());
    fabric.util.loadImage(this.setImageViewExt(), (img) => {
      let imgInstance = new fabric.Image(img);
      let ratio = this.calcImageSize(imgInstance.width, imgInstance.height).ratio;
      imgInstance.set({
        hasControls: false,
        hasBorders: false,
        evented: false,
        scaleY: ratio,
        scaleX: ratio,
        originX: 'center',
        originY: 'center',
      });
      this.canvasExt.clear();
      this.canvasExt.add(imgInstance);
      this.canvasExt.calcOffset()
      this.canvasExt.centerObject(imgInstance);
      this.canvasExt.setActiveObject(imgInstance);
      this.canvasExt.renderAll();
      // this.endResizeImage();

    });
    this.setDimensionImage()

  }

  /*
  ** Boolean value has emmited by child  if File input selected
  */
  getViewIsUpload(isUpload) {
    switch (this.getHpService().getView()) {
      case '0':
        this.isUploadExt = isUpload;
        break;
      case '1':
        this.isUploadInt = isUpload;
        break;
    }

  }

  setImageViewExt() {
     switch (this.getHpService().getIsUploadExt(this.getHpService().getView())) {

      case true:
        return (this.isExterior) ? this.viewExt : this.viewInt;

      default:
        this.viewExt = this.getHpService().getImageName("0");
        this.viewInt = this.getHpService().getImageName("1");
        let ambiance = (this.isExterior) ? this.getHpService().getUrl_ambiance() + "/ambiances/" + "/plgnd-sample-" + this.viewExt + ".jpg" :
          this.getHpService().getUrl_ambiance() + "/ambiances/" + "/plgnd-sample-" + this.viewInt + ".jpg";
        return ambiance
    }

  }
  setImageViewInt() {
    switch (this.getHpService().getIsUploadInt()) {
      case true:
        return this.viewInt;
        break;
      default:
        return this.getHpService().getUrl_ambiance() + "/ambiances/" + "/plgnd-sample-" + this.viewInt + ".jpg";
    }
  }

  getExtBackground() {

    return {
      background: this.viewExt
    };

  }
  getIntBackground() {

    return {
      background: this.viewInt
    };

  }


  toggleMenu(device: string) {

    this.warpable = false;
    this.element_showed =-1;
    switch (device) {
      case "mobile":

        this.menuAnswerStateMobile = 'out';
        this.menuReglageStateMobile = "in";
        this.menuQuestionStateMobile = "in";
        break;

      case "mobile-question":

        this.menuQuestionStateMobile = "out";
        this.menuReglageStateMobile = "in";
     
        break;

      case "mobile-expansion-question":
        this.asideTabletState = this.asideTabletState === "out" ? "in" : "out";
        //this.menuAnswerState = "in";
        this.menuAnswerStateMobile = "in";
        this.warpable_product = false;
        this.getHpService().setModalInfoOpened(false);
        this.getHpService().emitDataChange();
        this.getChangeDetectorRef().detectChanges();
        break;

      case "mobile-reglage":

        this.menuReglageStateMobile = "out";
        this.menuQuestionStateMobile = "in";
        this.menuAnswerStateMobile = 'in';
        break;

      case "aside-tablet":

        this.asideTabletState = this.asideTabletState === "out" ? "in" : "out";
        this.menuAnswerState = "in";
        this.multiMenuAnswerState ="out";
        this.getHpService().setModalInfoOpened(false);
        this.getHpService().emitDataChange();
        this.getChangeDetectorRef().detectChanges();
        break;
        
      case "aside-menu-expansion-windows":
          this.menuAnswersWindowsState =   this.menuAnswersWindowsState === "in" ? "out": "in";
          this.menuAnswerState = "in";
          this.multiMenuAnswerState ="in";
          break;
      case "aside-step-multi-menu":
            this.menuAnswersStepMenuState =   this.menuAnswersStepMenuState === "in" ? "out": "in";
            this.menuAnswerState = "in";
            this.multiMenuAnswerState ="in";
            break;    
          
      case "menu-answer-multi":
          this.multiMenuAnswerState = 'out';
          this.getHpService().setMultiMenuAnswerState( this.multiMenuAnswerState);
          this.getHpService().emitDataChange();
          this.getChangeDetectorRef().detectChanges();
          break;
      default:
          this.menuAnswerState = 'out';
          this.getHpService().setMenuAnswerState( this.menuAnswerState);
        
       
    }
    this.menuBottom_active = "";
    this.menuImage = false;
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();

  }

  getMenuAnswerState() {
    return this.menuAnswerState;
  }

  closeAllMenu() {
    this.menuState = 'in';
    this.menuRightState = 'in';
    this.menuState = 'in';
    this.menuFormeState = 'in';
    this.menuModeleState = "in"
    this.menuAnswerStateMobile = "in";
    this.menuQuestionStateMobile = "in";
    this.menuReglageStateMobile = "in";
    this.menuReglageRightState ="in";
    this.menuReglageLeftState ="in";
    this.menuReglageLeftState ="in";
    this.modelPanelOpenState = false;
    this.menuAnswerState = "in";
    this.getHpService().setMenuAnswerState("in");
    this.elementCurrent = "hidden";
    this.asideTabletState = "in";
      this.multiMenuAnswerState = "in";
    this.getHpService().setMultiMenuAnswerState("in");
    this.currentCode = -1;
    this.getChangeDetectorRef().detectChanges();
    this.getHpService().emitDataChange();
    this.getChangeDetectorMultiRef().detectChanges();
    this.getHpService().emitDataChange();

  }

  closeMenu() {
    this.menuState = 'in';
    this.menuRightState = 'in';
    this.menuState = 'in';
    this.menuFormeState = 'in';
    this.menuModeleState = "in"
    this.menuAnswerState = 'in';
    this.multiMenuAnswerState = "in";
    this.menuQuestionStateMobile = "in";
    this.menuReglageStateMobile = "in";
    this.asideTabletState = "in";
    this.currentCode = -1;

  }

  setElementCurrent(name) {
    this.elementCurrent = name;
  }

  getElementCurrent() {
    return this.elementCurrent;
  }


  removeTiret(str: string) {
    let re = /-/gi;
    return str.replace(re, " ");
  }

  getStyles(w: number) {
    return {
      width: w == 0 ? "186px" : "271px"
    };
  }

  getStyleView(w: number) {
    return {
      width: w == 0 ? "186px" : "271px"
    };
  }
  setClassView(bool): string {
    return bool ? "view-showed" : "view-hidden";
  }
  getClassActive(bool): string {
    return bool ? "item-active" : "item-inactive";
  }


  hideBorder() {
    this.tierceIndex = -1;
  }


  hideSidenav() {
    this.menuRightState = 'in';
    this.menuState = 'in';
  }

  getMatrix3d(matrix) {
    let ext = document.querySelector(".target");
    let int = document.querySelector(".target-in");
    this.warpMatrix = matrix;
    this.frames.set('transform', 'matrix3d', matrix);
    this.setTransform(ext);
    this.frameInt.set('transform', 'matrix3d', matrix);
    this.setTransformInt(int);
    this.hideMoveableControler();
  }

  getmenuLeftStatut(statut: string) {
    this.menuState = statut;
  }

  getmenuRightStatut(statut: string) {
    this.menuRightState = statut;
  }

  reInit() {
    console.log("debut Reint >>>>>>>>>>>>>>>>>" + this.getHpService().getView())
    this.answerProgress = true;
    this.closeAllMenu();
    console.log("debut Reint >>>>>>>>>>>>>>>>>")
    let ext = document.querySelector(".target");
    let int = document.querySelector(".target-in");
    let matrix3d = [
      1, 0, 0, 0,
      0, 1, 0, 0,
      0, 0, 1, 0,
      0, 0, 0, 1,
    ];
    let vue = (this.isExterior) ? "0" : "1";
    switch (vue) {
      case '0':
    
        this.frames.set('transform', 'matrix3d', matrix3d);
        this.frames.set('left', `${60}%`);
        this.frames.set('top', `${20}%`);
        this.setTransform(ext);
        this.wizardImageIntControllerComponent.updateImagesRect();
        break;
      case '1':
        this.frameInt.set('transform', 'matrix3d', matrix3d);
        this.frameInt.set('left', `${60}%`);
        this.frameInt.set('top', `${20}%`);
        this.setTransform(ext);
        this.wizardImageIntControllerComponent.updateImagesRect();
        break;
    }
    if (this.getHpService().getConfig().herculepro.hasDimension) {
      this.getHpService().fetchOneProduct(this.getHpService().getCatId(), this.getHpService().getInitProduct(), true).subscribe(data => {
        this.getHpService().setGlobaldata(data);
        this.answerProgress = false;
      });
    }

    this.getHpService().putAnswerSelected(this.getHpService().getCatId(),
      this.getHpService().getRootProductId(), this.getHpService().getRootProductElt(),
      this.getHpService().getElementObjects('GAMME').id,
      this.getHpService().getDefaultProduct().idGamme, "", "").subscribe({
        next: (data: any) => {
          this.getHpService().setGlobaldata(data);
          this.getHpService().emitDataChange();
          this.assignQuestionToAnswers(this.getHpService().getElementObjects('GAMME').id, data);

          //maintenant on fait un appel a la sous-question pour recupérer les valeurs

          this.getHpService().putAnswerSelected(this.getHpService().getCatId(),
            this.getHpService().getRootProductId(), this.getHpService().getRootProductElt(), this.getHpService().getQuestionObject('TYPE_DE_GAMME').id, this.getHpService().getDefaultProduct().idTypeGamme, "", "").subscribe({
              next: (data: any) => {
                this.getHpService().setGlobaldata(data);
                this.getHpService().emitDataChange();

                this.putAnswerSelected(this.getHpService().getElementObjects('MODELE').id, this.getHpService().getDefaultProduct().idModele, this.getHpService().getRootProductElt());
                this.putAnswerSelected(this.getHpService().getElementObjects('COULEUR').id, this.getHpService().getDefaultProduct().idColor, this.getHpService().getRootProductElt());
                this.putAnswerSelected(this.getHpService().getElementObjects('FORME').id, this.getHpService().getDefaultProduct().idForme, this.getHpService().getRootProductElt());

              },
              error: (error) => {
              this.isLoading = false;
                console.log('error');

              }
            });


          this.getHpService().emitDataChange();

        },
        error: (error) => {
          console.log('error');

        }
      });
    this.hideMoveableControler();
  }



  setInitForme() {
    let ext = document.querySelector(".target");
    let int = document.querySelector(".target");
    let matrix3d = [
      1, 0, 0, 0,
      0, 1, 0, 0,
      0, 0, 1, 0,
      0, 0, 0, 1,
    ];
    switch (this.view) {
      case '0':
        this.frames.set('transform', 'matrix3d', matrix3d);
        this.setTransform(ext);
        break;
      case '1':
        this.frameInt.set('transform', 'matrix3d', matrix3d);
        this.setTransformInt(int);
        break;
    }
  }

  inverserPorte() {

    switch (this.getHpService().getView()) {
      case '0':
        this.inReverseExt = (this.inReverseExt) ? false : true;
        this.inReverseInt = (this.inReverseInt) ? false : true;
        this.isFlippedHorizontallyMulti[this.product_index] = this.isFlippedHorizontallyMulti[this.product_index] ? false : true;
        this.getHpService().setInReverse(this.inReverseExt);
        
        break;
      case '1':
        this.inReverseInt = (this.inReverseInt) ? false : true;
        this.inReverseExt = (this.inReverseExt) ? false : true;
        this.getHpService().setInReverse(this.inReverseInt);
        break;
    }
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
  }

  getClassPorte() {
    switch (this.view) {
      case '0':
        return this.inReverseExt ? "in-reverse" : "no-reverse";
        break;
      case '1':
        return this.inReverseInt ? "in-reverse" : "no-reverse";
        break;
      default:
        return "no-reverse";
    }
  }

  getView() {
    return this.getHpService().getView();
  }

  setIndexElement(id) {
    this.indexElements = id;
    this.elementId = 1;
    this.hideBorder();
  }
  sharePhoto() {
    this.answerProgress = false;
    this.shareBtn = true;
    this.closeDialog();
    this.menuImage = false;
    this.warpable = false;
    this.warpableInt = false;
    this.pdf_ok = true;
    this.getHpService().setFramesExt(this.frames);
    this.getHpService().setFramesInt(this.frameInt);
    var priceBlock = document.getElementById('priceBlock') as HTMLElement;
    let targetCss = (this.getHpService().getView() === '0') ? document.getElementById('target') as HTMLInputElement : document.getElementById('targetInt') as HTMLInputElement;
    let div_screen = (this.getHpService().getView() === '0') ? "#screenExt" : "#screenExt";
    
    if (priceBlock && priceBlock.style) {
      priceBlock.style.display = "none";
    }
    
    domtoimage.toBlob(document.querySelector(div_screen)).then(dataUrl => {
      domtoimage.toBlob(document.querySelector(div_screen), { scrollY: -window.scrollY, useCORS: true }).then(blob => {
        let fd = new FormData();
        fd.append('imageData', blob);
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => {
          this.base64String = reader.result.toString();
          this.getHpService().setbase64String(this.base64String);

          var currentData = this.getHpService().getCurrentSimulationData();
          console.log('currentData', currentData);
          var formData = {
            "CLI_NOM": this.getHpService().getSlug(),
            "PRODUCTS_DATA" : currentData
          }

          /*
          for (var i = 0; i < currentData.length; i++) {
            formData[currentData[i].code] = currentData[i].label_answer;
          }
          */

          formData["IMG_LOGO"] = this.getHpService().getAssetsFullPath() + '/assets/images/logos/'
            'logo.png';


          var dataMenuiserie = {
            "imageData": this.getHpService().getbase64String(),
            "modelGuid": this.getHpService().getPdfModelGuid(),
            "formData": formData
          }

          var datam = btoa(encodeURIComponent(JSON.stringify(dataMenuiserie)));
          let nextIdx = this.getIndexNextUrl('simulateur-finalisation');

          if (nextIdx > -1) {

            this.getHpService().setCurrentPage(nextIdx);
            this.pdf_ok = false;
            this.toLink('simulateur-finalisation');

          } else {

            var data = {
              vueExt : this.getHpService().getImageName('0'),
              vueInt : this.getHpService().getImageName('1')
            }

            this.getHpService().saveProject(data).subscribe({
              next: (data) => {
                var cwData = data.root;
                this.getHpService().postExternalMessage('CONFIGURATION_SAVED', cwData);
                this.pdf_ok = false;
                priceBlock.style.display = "block";
              },
              error: (error) => {
                this.pdf_ok = false;
                this.isLoading = false;
                this.getHpService().emitDataChange();
                this.showModalMessage(error, this.dialog);
                console.log('error');
              }
            });
          }
        }
      }).catch(function (error) {
        console.error('oops, something went wrong!', error);
      });
    });
  }

  showModalMessageDialog() {

    this.closeAllMenu();
    this.warpable = false;
    this.showProperty = false;
    this.dialogVue_active = true;
    this.getHpService().emitDataChange();
    if (this.isExterior) {
      this.getHpService().setView("0");
    }
    else {
      this.getHpService().setView("1");
    }
   
 
    const dialogRef = (this.isMobile) ? this.dialog.open(MaisonMobileComponent, {
      panelClass: 'full-width-dialog-vue-maison',
      data: {  }
    }) : this.dialog.open(vueMaisonComponent, {
      panelClass: 'full-width-dialog-vue-maison',
      data: { }
    });
    this.setElementCurrent('hidden');
    this.menuRightState = "in";
    this.menuState = "in";
    this.menuQuestionStateMobile = "in";
    this.menuReglageStateMobile = "in";
    this.asideTabletState = "in";
    this.menuAnswersWindowsState = "in";
    this.menuAnswersStepMenuState = "in";
    let me = this;
    dialogRef.afterClosed().subscribe(result => {
    this.getHpService().emitDataChange();
  
    });
    this.getHpService().emitDataChange();

  }
  
  showModalMessage(obj : any, dialog : MatDialog) {
  
    this.isLoading = false;
    var dialogConfig = new MatDialogConfig();
    dialogConfig.id = "std-modal-component";
    dialogConfig.width = "40%";
    dialogConfig.panelClass = 'std-modal-component';
    dialogConfig.position = {
      top: '30vh',
      left: '30vw'
    };
    var msg = '';
    if (obj && obj.error && obj.error.root && obj.error.root.error ) {
      msg = "Des options obligatoires ne sont pas renseignées, veuillez compléter votre saisie.";
    }
    dialogConfig.data = {
      message : msg
    };

    var modalDialog = dialog.open(ModalInfoComponent, dialogConfig);
    modalDialog.afterClosed().subscribe(result => {
      
      this.asideTabletState = "out";
      this.getHpService().emitDataChange();
      this.getChangeDetectorRef().detectChanges();
    
      });
  }

  dataURItoBlob(dataURI, mime) {
    let byteString = window.atob(dataURI);
    let ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    let blob = new Blob([ia], { type: mime });
    return blob;
  }

  showMap(statut: string) {
    this.viewMap = statut;
  }

  hideMap() {
    this.viewMap = "0";
  }
  /** * Get Data StreetView */
  getDataMap(data) {
    this.dataMap = data;
  }

  disableChildRefresh() {
    this.getChangeDetectorRef().detach();
  }

  enableChildRefresh() {
    this.getChangeDetectorRef().reattach();
  }



  onDragMap(e) {
    this.desactiveHammerjs();
    this.disableChildRefresh();
    this.wizardImageControllerComponent.updateMapImagesRect();

    e.target.style.transform = e.transform;
  }

  onDragMapEnd({ target, isDrag, clientX, clientY }) {

    console.log("onDragEnd", target, isDrag, clientX, clientY);
  }

   frame_map = {
    translate: [0, 0],
  };
  onResizeStart(e) {
    e.setOrigin(["%", "%"]);
    e.dragStart && e.dragStart.set(this.frame_map.translate);
  }
  onResize(e) {
    this.desactiveHammerjs();
    this.disableChildRefresh();
    this.wizardImageControllerComponent.updateMapImagesRect();
    e.target.style.width = `${e.width}px`;
    e.target.style.height = `${e.height}px`;
    e.target.style.transform = e.drag.transform;
       }
    
  setTransformMap(target) {
    target.style.cssText = this.frameMap.toCSS();
  }
  onRender(e) {
           e.target.style.cssText =  e.target.style.cssText + e.cssText;
       }
  startSimuleo() {
    this.simulation_in = this.simulation_in ? false : true;
    this.start_simuleo = true;
    this.initView = '1';
    this.getHpService().setStatut_user(true);
    this.toLink('etape-aide');
  }

  initValueint() {
    this.initView = '1';
  }

  toLink(url) {
    if (this.starWrap) {
      let paramsCss =
      {
        "left": "60%",
        "top": "20%",
        "transform": "unset"
      }
      this.getHpService().setCssTarget(paramsCss);
    }
    if (this.starWrapInt) {
      let paramsCss =
      {
        "left": "60%",
        "top": "20%",
        "transform": "unset"
      }
      this.getHpService().setFramesExt(this.frames);
      this.getHpService().setFramesInt(this.frameInt);
      this.getHpService().setCssTargetInt(paramsCss);
    }

    this.getHpService().setFramesExt(this.frames);
    this.getHpService().setFramesInt(this.frameInt);

    this.getRouter().navigate([url]);
  }

  displayFn(porte: Porte): string {
    return porte && porte.name ? porte.name : '';
  }

  displayForme(id) {
    return this.formesId[0].indexOf(id) !== -1;
  }

  closeFiltre() {
    this.panelOpenState = false;
  }

  onPress(evt) {
    this.warpable = true;
  }


  /* HammerJS */
  initPorteHammerjs() {
    let obj = document.getElementById("target") as HTMLElement;
    let mc = new Hammer(obj);
    let rotate = new Hammer.Rotate();
    let pinch = new Hammer.Pinch();
    let pan = new Hammer.Pan();
    mc.add([pinch, pan, rotate]);
    mc.get('pinch').set({ enable: true });
    mc.get('rotate').set({ enable: true });
    mc.get('pan').set({ enable: true });
    let adjustDeltaX = 0;
    let adjustDeltaY = 0;
    let adjustScale = 1;
    let adjustRotation = 0;
    let currentDeltaX = null;
    let currentDeltaY = null;
    let currentScale = null;
    let currentRotation = null;
    mc.on("panstart pinchstart rotatestart", (e) => {
      adjustRotation -= e.rotation;
    });
    mc.on("panmove pinchmove rotatemove", (e) => {
      currentRotation = adjustRotation + e.rotation;
      currentScale = adjustScale * e.scale;
      currentDeltaX = adjustDeltaX + (e.deltaX / currentScale);
      currentDeltaY = adjustDeltaY + (e.deltaY / currentScale);
      currentScale = (adjustScale * e.scale === 0) ? 1 : adjustScale * e.scale;
      this.frames.set('transform', 'scaleX', currentScale);
      this.frames.set('transform', 'scaleY', currentScale);
      this.frames.set('transform', 'rotate', Math.round(currentRotation) + 'deg');
      this.setTransform(obj);
      this.hammerScale = adjustScale * e.scale;


    });
    mc.on("panend pinchend rotateend", (e) => {
      adjustScale = currentScale;
      adjustRotation = currentRotation;
      adjustDeltaX = currentDeltaX;
      adjustDeltaY = currentDeltaY;
    });
  }


  initHammerjsCroll(obj, isEnable) {
    obj = document.getElementById('imageExt');
    let mc = new Hammer(obj);
    let pinch = new Hammer.Pinch();
    let pan = new Hammer.Pan();
    mc.add([pinch, pan]);

    let currentScroll = 0;
    mc.get('pinch').set({ enable: false });
    mc.get('pan').set({ enable: isEnable });
    let adjustScale = 1;
    let currentScale = null;
    let adjustDeltaX = 0;
    let adjustDeltaY = 0;
    let currentDeltaX = null;
    let currentDeltaY = null;
    mc.on("panstart", function (ev) {
      currentScroll = window.scrollY;
    });
    mc.on("pan", function (e) {
      if (currentScale == 1) {
        //abort pan and scroll window instead
        window.scrollTo(0, currentScroll + e.deltaY * -1);
        return;
      }

      let transforms = [];
      currentScale = adjustScale * e.scale;
      currentDeltaX = adjustDeltaX + (e.deltaX / currentScale);
      currentDeltaY = adjustDeltaY + (e.deltaY / currentScale);

      transforms.push('scale(' + currentScale + ')');
      obj.style.transform = transforms.join(' ');
    });
    mc.on("pinch", function (e) {
      let transforms = [];

      currentScale = adjustScale * e.scale;
      currentDeltaX = adjustDeltaX + (e.deltaX / currentScale);
      currentDeltaY = adjustDeltaY + (e.deltaY / currentScale);
      transforms.push('scale(' + currentScale + ')');
      obj.style.transform = transforms.join(' ');

    })

    mc.on("panend pinchend rotateend", function (e) {
      adjustScale = currentScale;
      //adjustRotation = currentRotation;
      adjustDeltaX = currentDeltaX;
      adjustDeltaY = currentDeltaY;

    })
  }



  initHammerjs(isEnable) {

    let obj = (this.isExterior) ? document.getElementById("imageExt") : document.getElementById("imageInt");
    this.mc = new Hammer(obj);
    let rotate = new Hammer.Rotate();
    let pinch = new Hammer.Pinch();
    let pan = new Hammer.Pan();
    this.mc.add([pinch, pan, rotate]);
    this.mc.get('pinch').set({ enable: isEnable });
    this.mc.get('rotate').set({ enable: isEnable });
    this.mc.get('pan').set({ enable: isEnable });

    let adjustDeltaX = 0;
    let adjustDeltaY = 0;
    let adjustScale = 1;
    let adjustRotation = 0;

    let currentDeltaX = null;
    let currentDeltaY = null;
    let currentScale = null;
    let currentRotation = null;
    this.mc.on("panstart pinchstart rotatestart", function (e) {
      adjustRotation -= e.rotation;
    });
    this.mc.on("panmove pinchmove rotatemove", function (e) {
      currentRotation = adjustRotation + e.rotation;
      currentScale = adjustScale * e.scale;
      currentDeltaX = adjustDeltaX + (e.deltaX / currentScale);
      currentDeltaY = adjustDeltaY + (e.deltaY / currentScale);

      let transforms = ['scale(' + currentScale + ')'];
      transforms.push('translate(' + currentDeltaX + 'px,' + currentDeltaY + 'px)');
      transforms.push('rotate(' + Math.round(currentRotation) + 'deg)');
      obj.style.transform = transforms.join(' ');
    });
    this.mc.on("panend pinchend rotateend", function (e) {
      adjustScale = currentScale;
      adjustRotation = currentRotation;
      adjustDeltaX = currentDeltaX;
      adjustDeltaY = currentDeltaY;
    });
  }


  initHammerMobile(isEnable) {

    let obj = document.getElementById("screenExtTest");
    let mc = new Hammer(obj);

    let rotate = new Hammer.Rotate();
    let pinch = new Hammer.Pinch();
    let pan = new Hammer.Pan();
    mc.add([pinch, pan, rotate]);
    mc.get('pinch').set({ enable: isEnable });
    mc.get('rotate').set({ enable: isEnable });
    mc.get('pan').set({ enable: isEnable });

    let adjustDeltaX = 0;
    let adjustDeltaY = 0;
    let adjustScale = 1;
    let adjustRotation = 0;

    let currentDeltaX = null;
    let currentDeltaY = null;
    let currentScale = null;
    let currentRotation = null;
    mc.on("panstart pinchstart rotatestart", function (e) {
      adjustRotation -= e.rotation;
    });
    mc.on("panmove pinchmove rotatemove", function (e) {
      currentRotation = adjustRotation + e.rotation;
      currentScale = adjustScale * e.scale;
      currentDeltaX = adjustDeltaX + (e.deltaX / currentScale);
      currentDeltaY = adjustDeltaY + (e.deltaY / currentScale);

      let transforms = ['scale(' + currentScale + ')'];
      transforms.push('translate(' + currentDeltaX + 'px,' + currentDeltaY + 'px)');
      transforms.push('rotate(' + Math.round(currentRotation) + 'deg)');
      obj.style.transform = transforms.join(' ');
    });
    mc.on("panend pinchend rotateend", function (e) {
      adjustScale = currentScale;
      adjustRotation = currentRotation;
      adjustDeltaX = currentDeltaX;
      adjustDeltaY = currentDeltaY;
    });

  }

  getHammerIsActive() {

    return this.hammer_active;
  }

  activeHammerjs() {
    this.hammer_active = true;
    this.initHammerjs(true);
    //this.initHammerMobile(true);
  }

  desactiveHammerjs() {
    this.hammer_active = false;
    let obj = (this.isExterior) ? document.getElementById("imageExt") : document.getElementById("imageInt");
    this.mc = new Hammer(obj);
    this.mc.get('pinch').set({ enable: false });
    this.mc.get('rotate').set({ enable: false });
    this.mc.get('pan').set({ enable: false });
  }
  findIndexByTypeValue(variable: any, var_editable) {
    const found = (element) => element.code === 'TYPE_DE_' + var_editable;
    return (variable.findIndex(found));
  }

  assignQuestionToAnswers(questionId: any, answers: any) {
    this.getHpService().assignQuestionToAnswers(questionId, answers);
  }
  assignMultiQuestionToAnswers(questionId: any, answers: any) {
    this.getHpService().assignQuestionToAnswers(questionId, answers);
  }
  getCurrentGrpId() {
    return this.currentGrpId;
  }

  getCurrentQstId() {
    return this.currentQstId;
  }

  onFilterChangeDataReceived(result) {

  }

  public onDataRetrieved(result: any) {

    var answers = {
      root: {
        data: result.items
      }
    };

    if (result.callback_prms != null
      && result.callback_prms.id != null) {
      this.getHpService().assignQuestionToAnswers(result.callback_prms.id, answers);
    }
   this.answers = answers;
   this.product_answers = answers;
   this.getChangeDetectorRef().detectChanges();
   this.getHpService().emitDataChange();
  }
  /**Hp service */
  /**
  * Get Answers
  * @param catId
  * @param prodId
  * @param code
  */
  fetchAnswers(grpId: any, categoryId: any, elementId: any, variable, code_type, key, index_) {
  
    this.getHpService().setSubTitleSelected(false);
    this.questionTitleAnswers = null;
    this.answers = null;
    this.currentGrpId = grpId;
    this.currentQstId = categoryId;
    console.log(this.getHpService().getCatId())
   this.getHpService().fetchAnswers(this.getHpService().getCatId(), this.getHpService().getProductId(), categoryId,
      this.getHpService().getRootProductElt()).subscribe({
        next: (data) => {
          this.assignQuestionToAnswers(categoryId, data);
          this.answers = data;
            if (this.getHpService().getQuestionIsTitle(categoryId)) {
            //si la question en cours est en mode titre.
            //alors on recupere les reponses a la sou-question lié.
            //on recupere l'id de la sous-question lié qui est masquée.
            let childQuestionId = this.getHpService().getLinkedSubQuestionId(categoryId);
            if (childQuestionId != null) {
              //maintenant on fait un appel a la sous-question pour recupérer les valeurs
              this.getHpService().fetchAnswers(this.catId, this.getHpService().getProductId(),
                childQuestionId,
                this.getHpService().getRootProductElt()).subscribe(subData => {

                  this.assignQuestionToAnswers(childQuestionId, subData);
                  this.questionTitleAnswers = subData; //this.answers;
                  this.getChangeDetectorRef().detectChanges();
                  this.getHpService().emitDataChange();
                  });
            }
          }
          this.menuQuestionStateMobile = "in";
          this.menuAnswerStateMobile = "out";

        
          this.getHpService().emitDataChange();
          
        },
        error: (error) => {
          console.log('error'); // Pas reponse de tout  avec erreur
        }
      });
  }



  /**Hp service Multi */
  /**
  * Get Answers
  * @param catId
  * @param prodId
  * @param code
  */
  fetchAnswersProducts(grpId: any, categoryId: any, elementId: any, variable, code_type, key, index_) {
     this.getChangeDetectorRef().detectChanges();
    this.getHpService().emitDataChange();
    this.getHpService().setSubTitleSelected(false);
      this.questionTitleAnswersProduct = null;
      this.product_answers  = null;
      this.currentGrpId = grpId;
      this.currentQstId = categoryId;
     
      this.getHpService().fetchProductAnswers(this.getHpService().getCatId(), this.getHpService().getProductId(), categoryId,
        this.getHpService().getRootProductElt()).subscribe({
          next: (data) => {
            this.assignQuestionToAnswers(categoryId, data);
            this.product_answers = data;
            this.getHpService().setProduct_answers(data);
            this.getHpService().emitDataChange();
            this.getChangeDetectorRef().detectChanges();
            if (this.getHpService().getQuestionIsTitle(categoryId)) {
              
              let childQuestionId = this.getHpService().getLinkedSubQuestionId(categoryId);
              if (childQuestionId != null) {
                //maintenant on fait un appel a la sous-question pour recupérer les valeurs
                this.getHpService().fetchAnswers(this.getHpService().getCatId(), this.getHpService().getProductId(),
                  childQuestionId,
                  this.getHpService().getRootProductElt()).subscribe(subData => {
                    this.assignQuestionToAnswers(childQuestionId, subData);
                    this.questionTitleAnswersProduct = subData; //this.answers;
                    this.getHpService().emitDataChange();
                    this.getChangeDetectorRef().detectChanges();
                  });
                  
              }
            }
            this.menuQuestionStateMobile = "in";
            this.menuAnswerStateMobile = "out";
            this.getHpService().emitDataChange();
            this.getChangeDetectorRef().detectChanges();
          },
          error: (error) => {
            console.log('error'); // Pas reponse de tout  avec erreur
          }
        });
    }





  /**
   * 
   * @returns list de differents type d'un produit (gamme,vitrage,...)
   */
  getCurrentQuestionTitleAnswers() {

    if (this.questionTitleAnswers && this.questionTitleAnswers.root && this.questionTitleAnswers.root.data) {
      return this.questionTitleAnswers.root.data;
    }
    return null;
  }

    /**
   * 
   * @returns list de differents type d'un produit (gamme,vitrage,...)
   */
  getCurrentQuestionTitleAnswersProduct() {
    
    if (this.showMultiProduct && this.questionTitleAnswersProduct && this.questionTitleAnswersProduct.root && this.questionTitleAnswersProduct.root.data) {
      return this.questionTitleAnswersProduct.root.data;
    }
    
    return null;
  }

  setCurrentElement_Type(id) {
    if(this.showMultiProduct)
    {
      this.currentMultiElement_type[this.product_element ] =id
    }
    else{
      this.currentElement_type = id;
    }
    
  }

  getCurrentElement_Type() {
    if(this.showMultiProduct)
    {
      return this.currentMultiElement_type[this.product_element ];
    }

    return this.currentElement_type;
  }


  getCurrentAnswers() {
  
  if (this.showMultiProduct && this.product_answers  && this.product_answers.root &&  this.product_answers.root.data) {
    return    this.product_answers.root.data;
   } 
   if (this.answers && this.answers.root && this.answers.root.data) {
         return this.answers.root.data;
    }
    return null;
  }
  /**
  *
  * @param catId
  * @param prodId
  * @param idElement
  * @param variableId
  */
  public fetchCoteProd(catId: any, prodId: any, idElement: any, var_hId: any, valueH: any, var_lId: any, valueL: any) {

    this.getHpService().fetchCoteProd(catId, prodId, idElement, var_hId, valueH, var_lId, valueL).subscribe({
      next: (data) => {
        this.infos = data;
        this.getHpService().setGlobaldata(data);
      },
      error: (error) => {
        console.log('error'); // Pas reponse de tout  avec erreur

      },
    });

  }

  public setAnswer(data: any, code: any, label: any, key: any, answer_index: any, question_code: any, keyword: any) {
    this.currentCode = code;
    this.questionSelected = label;
    this.keySelected = key;
    this.answer_index = answer_index;
    this.question_code = question_code;
    this.qstKeywords = keyword
    console.log( question_code + " >> " +this.displayInfoAnswer(key))
  }

  public getcurrentQuestion() {
    this.current_question = {};

   this.current_question = {
      "currentCode": this.currentCode,
      "questionSelected": this.questionSelected,
      "keySelected": this.keySelected,
      "answer_index": this.answer_index,
      "question_code": this.question_code,
      "keywords": this.qstKeywords

    }
    let  current_question = {
      "currentCode": this.currentCode,
      "questionSelected": this.questionSelected,
      "keySelected": this.keySelected,
      "answer_index": this.answer_index,
      "question_code": this.question_code,
      "keywords": this.qstKeywords

    }
    this.getHpService().setcurrentQuestion(this.current_question);
     return current_question;

  }

  setQuestions(data: any) {
    this.questions = data;
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
  }
  setCouleurId(id: any) {
    console.log(this.isExterior)

    switch (this.isExterior) {
      case true:
        this.idCouleurExt = id;

        break;
      default:
        this.idCouleurInt = id
    }

  }

  public toggleViewInOut(event: any) {
    var isInsideView = false;
    var currentView = this.getHpService().getView();
  
   if(this.getHpService().getConfig().herculepro.multiProduct)
    {
      this.warpable_product = false;   
    }
    
    
    if (event != null && event.checked != null) {
      isInsideView = event.checked;
    } else {
      if (currentView == '0') {
        isInsideView = true;
      }
    }

    var qst = this.getHpService().getCurrentViewQuestion();
    if(this.getHpService().getConfig().herculepro.switchViewBy_frontend)
    {
      this.inverserPorte();
    }   
    this.setisExterior();
    this.getHpService().setView(this.getHpService().getView());
    this.closeAllMenu();

    var isForceMultiViews = this.getHpService().hasKeywords(this.getHpService().getRootProduct(), 'SYS.FORCE.MULTIVIEWS');
    this.hasInOrOutView =this.getHpService().getHasInOrOutView();
    if (qst != null || isForceMultiViews) {
      //VA 26.12.2023 - on stock la valeur des options déja selectionnées de la vue en cours.
      var currentSelections = {};
      var stockableViewQuestions = null;
      if (qst != null) {
        stockableViewQuestions = this.getHpService().getQuestionsViewStockable();
      }

      if (stockableViewQuestions != null) {
        for (var l in stockableViewQuestions) {
          var question = stockableViewQuestions[l];
          if (question && question.answers != null && question.answers.length > 0) {
            currentSelections[l] = question.answers[0].id;
          }
        }
        this.getHpService().setCurrentViewStockableAnswers(currentSelections, !isInsideView);
      }

      var resId = null;
      if (isInsideView) {
        resId = this.getHpService().getViewInsideAnswerId();
      } else {
        resId = this.getHpService().getViewOutsideAnswerId();
      }

      //this.answerProgress = true;
      var toRestoreStockableAnswers = this.getHpService().getCurrentViewStockableAnswers(isInsideView);

      var codes = '';

      if (resId != null && resId != '') {
        codes = resId + ',';
      } else {
        codes = 'DIRECT_KEYWORD__';
        if (isInsideView) {
          codes += 'SYS.VUE.INT';
        } else {
          codes += 'SYS.VUE.EXT';
        }
        codes += ',';
        codes += 'DIRECT_KEYWORD__';
        if (isInsideView) {
          codes += '-SYS.VUE.EXT';
        } else {
          codes += '-SYS.VUE.INT';
        }
        codes += ',';
      }
      if (toRestoreStockableAnswers != null) {
        for (var l in toRestoreStockableAnswers) {
          codes += toRestoreStockableAnswers[l] + ',';
        }
      }
      if (codes != null && codes != '') {
        codes = codes.substring(0, codes.length - 1);
        this.isLoading = true;
        this.switchViewLoading = true;
        this.getHpService().putMultipleAnswersSelected(this.getHpService().currentProductValue.catId,
          this.getHpService().currentProductValue.id, this.getHpService().getRootProductElt(), codes).subscribe({
            next: (data) => {
              this.isLoading = false;
              this.getHpService().setGlobaldata(data);
              if(this.switchViewClicked === 0)
              {
               this.openVueMaison( this.getHpService().getView());
               this.switchViewClicked++;
              }
              this.switchViewLoading = false;
              this.getHpService().emitDataChange();
              this.getChangeDetectorRef().detectChanges();
            },
            error: (error) => {
             this.isLoading = false;
              this.pdf_ok = false;
              this.getHpService().emitDataChange();
              this.getChangeDetectorRef().detectChanges();
              console.log('error');
              this.showModalMessage(error, this.dialog);
            }
          });
      } else {
        this.isLoading = false;
        this.switchViewLoading = false;
      }
    }
    
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
  }
  public putAnswerByCodeSelected(item: any, qstId: any, resId: any, elementId: any) {

   /*if(this.getHpService().getHasInOrOutView())
   {
    this.isExterior = 
   }*/
    var isFilterModule = this.getHpService().getConfig().menu_expansionPanel;
    var filterIdCode = this.getHpService().getConfig().menu_expansionPanelCategoryIdCode;
    var currentCartCode = this.getHpService().getQuestionICode(item.grpId, item.question_id);
    if (isFilterModule && filterIdCode != null && filterIdCode != '' && currentCartCode != null
      && currentCartCode == filterIdCode && item.keywords != null) {
      this.getHpService().selectItem(item.name, null, null);
      this.getChangeDetectorRef().detectChanges();
      this.getHpService().emitDataChange();

    }
    else {
      this.putAnswerSelected(qstId, resId, elementId);
    }

  }

  public putAnswerSelected(qstId: any, resId: any, elementId: any) {

    this.answerProgress = true;
    this.getHpService().setAnswerProgress(true);
    if (this.getHpService().getQuestionIsSubTitle(qstId)) {
      this.answers = null;
    }
    this.isLoading = true;
    this.getHpService().putAnswerSelected(this.getHpService().currentProductValue.catId,
      this.getHpService().currentProductValue.id, elementId, qstId, resId, "", "").subscribe({
        next: (data) => {
          this.isLoading = false;
          this.getHpService().setGlobaldata(data);
          this.getHpService().setCurrentAnswerWindowId(resId);
          let currentRoute = this.getRouter().url;
          if (currentRoute === '/simulateur-de-portes' && this.question_code === "COULEUR") {
            this.couleurQstId = (this.question_code === "COULEUR") ? this.couleurQstId : qstId;
            this.setCouleurId(resId);
          }
          this.getChangeDetectorRef().detectChanges();
          this.getHpService().emitDataChange();
          setTimeout(() => {
            if (this.isMobile) {
              this.closeAllMenu();
            }
            this.assignQuestionToAnswers(qstId, data);
            if (this.getHpService().getQuestionIsSubTitle(qstId)) {

              let childQuestionId = this.getHpService().getLinkedTopQuestionId(qstId);
              if (childQuestionId != null) {
                this.isLoading = true;
                //maintenant on fait un appel a la sous-question pour recupérer les valeurs
                this.getHpService().fetchAnswers(this.catId, this.getHpService().getProductId(),
                  childQuestionId,
                  this.getHpService().getRootProductElt()).subscribe(subData => {
                    this.isLoading = false;
                    this.assignQuestionToAnswers(childQuestionId, subData);
                    this.answers = subData;

                    this.getChangeDetectorRef().detectChanges();
                    this.getHpService().emitDataChange();
                  
                  });
              }
            }

            this.answerProgress = false;
            this.getHpService().setAnswerProgress(false);          
            this.getHpService().emitDataChange();
            this.getChangeDetectorRef().detectChanges();
            /*
            VA 26.03.2024 - le bloque ci-dessous provoque une boucle infinie dans le rechargement de l'option.
            A retravaillé (constaté sur CASEO)
            var isViewInsideOutSide =  this.getHpService().hasKeywords(this.getHpService().getRootProduct(), 'SYS.VUES.EXT') &&
                                       this.getHpService().hasKeywords(this.getHpService().getRootProduct(), 'SYS.VUES.INT');
            switch(true)
            {
              case !isViewInsideOutSide && this.getHpService().getView() === "1" && (this.getHpService().hasKeywords(this.getHpService().getRootProduct(), 'SYS.VUE.EXT')) :
                   //console.log(this.getHpService().getView() +" queExt " +this.getHpService().hasKeywords(this.getHpService().getRootProduct(), 'SYS.VUE.EXT'));
                   this.getViewValue("0");
                   this.putAnswerSelected(qstId, resId, elementId);
                   this.viewExt_int = "0";
                   break
              case !(isViewInsideOutSide) && this.getHpService().getView() === "0" && (this.getHpService().hasKeywords(this.getHpService().getRootProduct(), 'SYS.VUE.INT')) :
                   // console.log("que Int " +this.getHpService().hasKeywords(this.getHpService().getRootProduct(), 'SYS.VUE.INT'));
                    this.getViewValue("1");
                    this.putAnswerSelected(qstId, resId, elementId);
                    this.viewExt_int = "1"; 
                    break 
              default:
                    console.log("isViewInsideOutSide")          

            }
            */




          
          }, 10);
        },
        error: (error) => {
          this.isLoading = false;
          console.log('error');
        }
      });
      console.log(this.getHpService().getView())
  }

  public putAnswerMultiByCodeSelected(item: any, qstId: any, resId: any, elementId: any) {
   
    var isFilterModule = this.getHpService().getConfig().menu_expansionPanel;
    var filterIdCode = this.getHpService().getConfig().menu_expansionPanelCategoryIdCode;
    var currentCartCode = this.getHpService().getQuestionICode(item.grpId, item.question_id);
    var has_filter = (this.getHpService().isMultiProducts()) ? this.getHpService().getListCataglog()[this.menu_selected].has_filter : true;
   if (isFilterModule && filterIdCode != null && filterIdCode != '' && currentCartCode != null
      && currentCartCode == filterIdCode && item.keywords != null && has_filter) {
        console.log("simulateur.component" + this.getHpService().getViewInsideAnswerId())
        let me = this
       
      this.getHpService().selectItem(item.name, null, null).then(res =>{
        console.log(me.getHpService().getView() + "" + me.getHpService().getViewInsideAnswerId());
        me.hasInOrOutView = me.getHpService().getHasInOrOutView();
       // let gamme = me.getHpService().getQuestionObject('GAMME').answers[0].code
       // let keyFound = (me.getHpService().getConfig().herculepro.viewInterieurIn).indexOf(gamme); 
          me.getChangeDetectorRef().detectChanges();
          me.getHpService().emitDataChange();   
      });
     
   }
   else {
    console.log("simulateur.component else" + this.getHpService().getViewInsideAnswerId())
       this.putAnswerMultiSelected(qstId, resId, elementId);
       this.getChangeDetectorRef().detectChanges();
       this.getHpService().emitDataChange();
  }
     }
public putAnswerMultiSelected(qstId: any, resId: any, elementId: any) {
  
     this.isLoading = true;
     this.getChangeDetectorRef().detectChanges();
     this.getHpService().emitDataChange();
     this.answerProgress = true;
     if (this.getHpService().getQuestionIsSubTitle(qstId)) {
       this.product_answers = null;
     }
     this.isLoading = true;
     this.getHpService().putAnswerSelected(this.getHpService().currentProductValue.catId,
       this.getHpService().currentProductValue.id, elementId, qstId, resId, "", "").subscribe({
         next: (data) => {
           
           this.getHpService().setGlobaldata(data);
           this.isLoading = false;
           let currentRoute = this.getRouter().url;
           if (currentRoute === '/simulateur-de-portes' && this.question_code === "COULEUR") {
             this.couleurQstId = (this.question_code === "COULEUR") ? this.couleurQstId : qstId;
             this.setCouleurId(resId);
           }
           this.getChangeDetectorRef().detectChanges();
           this.getHpService().emitDataChange();
          
           setTimeout(() => {
             if (this.isMobile) {
               this.closeAllMenu();
             }
             this.assignMultiQuestionToAnswers(qstId, data);
        
             if (this.getHpService().getQuestionIsSubTitle(qstId)) {
 
               let childQuestionId = this.getHpService().getLinkedTopQuestionId(qstId);
        
               if (childQuestionId != null) {
                this.isLoading = true;
                 //maintenant on fait un appel a la sous-question pour recupérer les valeurs
                 this.getHpService().fetchAnswers(this.catId, this.getHpService().getProductId(),
                   childQuestionId,
                   this.getHpService().getRootProductElt()).subscribe(subData => {
                     this.isLoading = false;
                     this.assignQuestionToAnswers(childQuestionId, subData);
                     this.product_answers = subData;
 
                     this.getChangeDetectorRef().detectChanges();
                     this.getHpService().emitDataChange();
                   
                   });
               }
             }
 
             this.answerProgress = false;
             this.isLoading = false;
        
             this.wizardImageControllerComponent.updateProductReact();
              this.getChangeDetectorRef().detectChanges();
             this.getHpService().emitDataChange();
           
           }, 10);
        
          
         },
         error: (error) => {
          this.isLoading = false;
           console.log('error');
         }
         
       });
       //this.wizardImageControllerComponent.updateProductReact();
       this.getChangeDetectorRef().detectChanges();
      this.getHpService().emitDataChange();
   }

  public putVariablesValues(idElement: any, identifiantQuestion: any, identifiantReponse: any,
    varItem: any, event: any) {
    var variable = this.getHpService().getVariable(null, identifiantQuestion, varItem.var_id);
    var valueVariable = event.target.value;
    if (variable != null) {
      var currentValue = variable.var_value;
      if (valueVariable == currentValue) {
        return;
      }
    }

    if (valueVariable == '') {
      valueVariable = "null";
    }

    this.answerProgress = true;
    this.isLoading = true;
    this.getHpService().putVariablesValues(this.getHpService().currentProductValue.catId,
      this.getHpService().currentProductValue.id,
      idElement, identifiantQuestion, identifiantReponse, varItem.var_id, valueVariable).subscribe({
        next: (data) => {

          this.getHpService().setGlobaldata(data);
          this.answerProgress = false;
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          console.log('error');
        }
      });
  }

  getCurrentElement() {

    if (this.getHpService().getGroups()) {
      let questions = this.getHpService().getGroups()[this.keySelected] ?
        this.getHpService().getGroups()[this.keySelected].questions[this.answer_index].answers[0] :
        { id: "00000", value: "no value" }

      return questions;
    }
    return null;

  }

  pushVariable(index_, id) {
    this.answers_variableId[index_] = id;
  }

  getVariable(isValeur) {
    console.log(">><" + this.answers_variableId)
    return (isValeur === "valeur") ? this.answers_variable.join() : this.answers_variableId.join()
  }

  findIndexByPropertyValue(variable: any, var_editable) {
    const found = (element) => element.var_editable === var_editable;
    return (variable.findIndex(found));
  }

  getListProduct() {
    this.getHpService().getListProducts()
  }

  fetchOneProduct(prodId) {

    this.getHpService().fetchOneProduct(this.getHpService().getCatId(), prodId, true).subscribe(data => {
      this.getHpService().setGlobaldata(data);
      //this.prodId = prodId;
      let product = {
        id: this.getHpService().getProductId(),
        catId: this.getHpService().getCatId(),
        label: data.root.hasOwnProperty("product") && data.root.product ? data.root.product[0].label : ""
      }
      this.getHpService().setProduct(product);

    });
  }

  onFileChange(event) {
    this.closeAllMenu();
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      let self = this;
      reader.onload = () => {
        self.fileUpload_photo = reader.result.toString();
        switch (this.getHpService().getView()) {
          case '0':
            self.getHpService().setIsUploadExt(true);
            self.getHpService().setImageName(self.fileUpload_photo);
            self.getHpService().setVisual_type("upload-0");
            break;
          case '1':
            self.getHpService().setIsUploadInt(true);
            self.getHpService().setImageName(self.fileUpload_photo);
            self.getHpService().setVisual_type("upload-1");

            break;
        }
        self.getHpService().setImageName(reader.result.toString());
        self.getHpService().emitDataChange();
        console.log(this.getHpService().getVisual_type())
      };
    }
    this.getHpService().emitDataChange();
    console.log(this.getHpService().getVisual_type())
  }

  addWidth() {
    let element = document.getElementById('target') as HTMLInputElement;
    this.mobileTarget = element.offsetWidth + 1;
  }

  moinsWidth() {
    let element = document.getElementById('target') as HTMLInputElement;
    if (element.offsetWidth < 50) {
      return;
    }
    this.mobileTarget = element.offsetWidth - 1;
  }

  reInitePorte() {
    let element = document.getElementById('target') as HTMLInputElement;
    this.mobileTarget = 122;
  }

  toggleView() {
    return;
  }

  getConfig() {
    return this.getHpService().getConfig();
  }

  getProductForme(globalProduct: any) {

    if (!globalProduct) {
      return;
    }
    switch (true) {

      case globalProduct.hasImposte && globalProduct.hasLeftTierce && globalProduct.hasRightTierce:
        this.forme_selected = "area-center_tgtd";
        return "forme-imp-double";
      case globalProduct.hasImposte && (globalProduct.hasLeftTierce || globalProduct.hasRightTierce):
        this.forme_selected = (globalProduct.hasLeftTierce) ? "area-center_tg" : "area-center_td";
        return "forme-imp-tierce";
      case globalProduct.hasLeftTierce && globalProduct.hasRightTierce:
        this.forme_selected = "area-center_tgtd";
        return "forme-double";
      case globalProduct.hasLeftTierce:
        this.forme_selected = "area-center_tg";
        return "forme-tg";
      case globalProduct.hasRightTierce:
        this.forme_selected = "area-center_td";
        return "forme-td";
      case globalProduct.hasImposte:
        this.forme_selected = "area-center_";
        return "forme-imp";
      default:
        return "forme-simple";

    }

  }

  public getMainContainer() {
    return this.container;
  }

  displayTierce(globalProduct: any) {
    if (!globalProduct) {
      return;
    }
    return globalProduct.hasImposte || globalProduct.hasLeftTierce || globalProduct.hasRightTierce;
  }

  displayProductType(question: any) {
 
    if (question.hasSysSimTitle == true) {
      return true;
    }
    return false;
  }

  setisExterior() {
    this.isExterior = this.isExterior ? false : true;
    let vue = (this.isExterior) ? "0" : "1";
    this.viewExt_int = vue
    this.getHpService().setTypeVisuel("view-" + vue);
    this.visualType = "view-" + vue;
    this.getHpService().setView(vue);
    
    this.getViewValue(vue);
    this.wizardImageControllerComponent.updateImagesRect();
    let porteElement = document.querySelector(".target");
    this.setTransform(porteElement);
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
   }

 

  /**
   * 
   * @param keywords 
   * @param productKeywords
   * @returns nameClasse Product Area (tierce)
   */
  getClassArea(question: any, globalProduct: any) {

    if (this.getHpService().hasKeywords(question, 'SIM.GROUP.ROOT')) {
      return this.forme_selected;
    } else {
      
      let clsName = question.className;
      return clsName;
    }
  }

  /**
   * 
   * @param keywords 
   * @param productKeywords
   * @returns nameClasse Product Area (tierce)
   */
  getMultiClassArea(question: any, globalProduct: any) {

    if (this.getHpService().hasKeywords(question, 'SIM.GROUP.ROOT')) {
      return this.forme_selected;
    } else {
      
      let clsName = question.className;
      return clsName;
    }
  }

  /**
   * 
   * @param label 
   * @returns nameClasse Button by Label Menu left 
   */
  getnameClassButton(label: string) {
    if (!label) {
      return "menu-btn";
    }
    let nameClasse = (label) ? this.removeAccents(label) : "";
    nameClasse = (nameClasse.toLowerCase()).replace(' ', '-');
    return (nameClasse);

  }
  /**
   * 
   * @param label 
   * @returns nameClasse Button by Label Menu left 
   */
  setNameClassAnswerSide(label: string) {
    if (!label) {
      this.classNameAnswer_side = "answer-side_";
    }
    let nameClasse = (label) ? this.removeAccents(label) : "";
    nameClasse = (nameClasse.toLowerCase()).replace(' ', '-');
    this.classNameAnswer_side = "answer-side_" + nameClasse;

  }
  /**
   * 
   * @param str 
   * @returns str sans accent...
   */
  public removeAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  getMenuReglageRightState() {
    return this.menuReglageRightState;
  }
  getMenuReglageLeftState() {
    return this.menuReglageLeftState;
  }
  toggleMenuBottom(name) {
    this.warpable = false;
    this.warpableInt = false;
    switch (name) {
      case 'maison':
        this.bottomMenu = 'maison';
        break;
      case 'reglage':
        this.menuReglageRightState = this.menuReglageRightState === 'in' ? 'out' : 'in';
        break;
      case 'reglage-multi':
          this.menuReglageLeftState = this.menuReglageLeftState === 'in' ? 'out' : 'in';
          this.getChangeDetectorRef().detectChanges()
          this.getHpService().emitDataChange();
          break;  
      case 'mobile-expansion-question':
        this.menuBottom_active = "menu-question-mobile";
          break;  
      default:
        this.bottomMenu = 'setting';

    }
    this.menuReglageStateMobile = 'out';
    this.menuQuestionStateMobile = 'in';
    
  }

  toggleMenuRight() {

    this.menuState = 'in';
    this.menuQuestionStateMobile = 'in';
    this.menuRightState = this.menuRightState === 'out' ? 'in' : 'out';
    this.warpableInt = false;
    this.initView = '1';
  }


  getTargetAreaIndex() {
    return this.target_area_index;
  }

  selectArea(i: number, keyword: string) {
    this.target_area_selected = true;
    this.target_area_index = i;
    this.getChangeDetectorRef().detectChanges()
    this.getHpService().emitDataChange();
   }
   hideElementBorder() {
    if(!this.displayTierce(this.getHpService().getRootProduct()) || !this.getHpService().getUseDisplayBySubItems() )
    {
      return;
    }

    this.target_area_index =-1;
    this.target_area_selected = false;
   }


  public sortedProducts(arrayQuestion: any) {
    return arrayQuestion.sort((a, b) => a.order - b.order);
  }

  public getQuestionSelectedLabel() {
    return this.questionSelected;
  }

  public getInfoProduct() {
    (this.getHpService().getGlobaldata()) ? this.getHpService().getGlobaldata().root.full_desc : "<div></div>"
  }

  reset() {
    this.getHpService().setProduct(this.getHpService().getDefaultProduct().idModele)
  }
  checkIntView(keyword: string) {
    const isInViewInt = (element) => element === keyword;
    return this.getHpService().getConfig().herculepro.viewInterieurIn.findIndex(isInViewInt)
  }

  setKeywords(keywords): any {
    if (keywords) {
      return keywords;
    }

    return 'default-container-answer'
  }

  toPreviousPage() {

    if (this.getHpService().getConfig().herculepro.hasDimension) {
      this.getRouter().navigate(['familles']);
      return;
    }

    this.getRouter().navigate(['selecteur-de-portes']);
  }

  getClassName(keywords) {
    if (keywords) {
      return keywords.replace(/,/gi, ' ').toLowerCase();
    }
  }

  hasAnswers(answers:any)
  {
    if(!(this.shareBtn))
      {
        return "has_answers";
      }
    
    if(answers)
      {
        return "has_answers";
      }
    return "no_answers";

  }

  getObserveMobile() {
    return this.getHpService().getIsMobile();
  }

  getMultiGlobaldata(){
    return this.getHpService().getMultiGlobaldata();
  }
  /**
   * Ajout un nouveau catalog 
   */
  addObject(show,index_)
  {
   
     this.warpableProduct = false;
     this.warpable_index = -1;
     this.product_element =index_;
     this.currentIndex=index_;

       let frame = new Frame({
          left: '40%',
          top: '40%',
          display: show ? 'block': 'none',
          transform: {
            rotate: '0deg',
            scaleX: 1,
            scaleY: 1,
            matrix3d: this.warpMatrix ,
          },
          });
        this.productsFrames.push(frame);
        this.transformCss_w.push("rotate(0deg) scaleX(1) scaleY(1) matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)");
        this.getHpService().settransformCss_w("rotate(0deg) scaleX(1) scaleY(1) matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)");
        this.getHpService().setproductsFrames(this.productsFrames);
        this.isFlippedHorizontallyMulti.push(false); 
        this.product_index++;
        this.createProductIndex ++;
        this.getHpService().setCurrentProductIndex(this.createProductIndex); 
       this.getHpService().emitDataChange();   
         
  }
 getProductFrames()
  {
    return this.productsFrames;
  }
  showProductControl(_index){
  console.log(_index)
  this.warpable = false;
  this.warpable_product = true;
  this.warpable_index =_index;
  this.getHpService().emitDataChange();
  this.getChangeDetectorRef().detectChanges();
  
    }
  setShowMultiproduct(showed)
  {
  this.getHpService().setShowMultiproduct(showed);
  this.showMultiProduct = showed;
  this.getChangeDetectorRef().detectChanges()
  this.getHpService().emitDataChange(); 
  }
  getShowMultiproduct()
  {
  return this.getHpService().getShowMultiproduct();
  }          

  setCurrentProductIndex(i)
  {
    this.product_element = i;
    this.currentIndex=i;
    this.warpable_index  =i;
    this.product_index = i;
    this.catalog_index = this.getHpService().getListCalogLoaded()[i].navCat_index;
    this.getHpService().setCatalogIndex(this.catalog_index);
    //this.getHpService().setCurrentProduct(this.list_catalog[i].catalog.slug);
    this.catalog_selected = this.catalog_index;
    this.menu_selected= this.catalog_index ;
    this.getHpService().setCurrentProductIndex(i);
    this.getHpService().setProductId();
    this.productsGlobalDtata = this.getHpService().getMultiProductGroups(); 
    this.stateDetail = 'in'
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
  }
  
  emitEventToWizarImage() {
    this.eventsSubject.next();
     }

 
 /**
  * Load Product avec ajout du visuel de produit dans data*/
 loadProduct(show,item,i)
 {
  
  this.showProduct_visua_menu = show; 
 this.getHpService().setBooleanParam("standard-menu-answer",false);
 let indexFound  = this.findIndexListCatalog("catalog",i);
  if(indexFound > -1 )
 {
  this.setCurrentProductIndex(indexFound);
  return;
 }
  let catalog = {"catalog":item, "navCat_index":i,"produc_index":this.createProductIndex }
  this.setShowMultiproduct(true);
  this.addObject(show,i);
  this.catalog_index = i;
  this.list_catalog.push(catalog);
  this.getHpService().setListCatalog(catalog);
  this.getHpService().loadMultiConfig(i,this.createProductIndex); 
  let me = this;
  this.getHpService().initToken().then(function (result) { 
  me.getHpService().doInitDirectMultiProduct(i,me.createProductIndex).then(function (result) { 
  me.getHpService().getproductsFrames()[me.createProductIndex].set('display', show ? `block`:`none`);
  me.productsFrames[me.createProductIndex].set('display', show ? `block`:`none`);
 
  
});  


});
me.getChangeDetectorRef().detectChanges()
me.getHpService().emitDataChange(); 
}
/**
 * 
 *Creation / ajout un produit le cas Fenetre 
 */
createProduct(asideMenu,show,item,i,keyword)
 {

 this.showProduct_visua_menu = show; 
 this.createLoading = true;
 this.getHpService().setCurrentKeyword(keyword);
 this.currentMenuProductStep = keyword
 this.getHpService().setBooleanParam("standard-menu-answer",false); 
this.setShowMultiproduct(true);
this.addObject(show,i);
this.catalog_index = i;
this.menu_selected = i;
let catalog = {"catalog":item, "navCat_index":i,"produc_index":this.createProductIndex }
this.list_catalog.push(catalog);
this.getHpService().setListCatalog(catalog);
this.getHpService().loadMultiConfig(i,this.createProductIndex); 
let me = this;
  this.getHpService().initToken().then(function (result) { 
  me.getHpService().doInitDirectMultiProduct(i,me.createProductIndex).then(function (result) { 
  me.getHpService().getproductsFrames()[me.createProductIndex].set('display', show ? `block`:`none`);
  me.productsFrames[me.createProductIndex].set('display', show ? `block`:`none`);
  me.fetchAnswersProducts(me.getHpService().getQuestionObject(keyword).grpId,me.getHpService().getQuestionObject(keyword).id,
  me.getHpService().getRootProductElt(),me.getHpService().getQuestionObject(keyword).code,me.getHpService().getQuestionObject(keyword),keyword,i)
  me.toggleMenu(asideMenu);  
 /* */
  me.getChangeDetectorRef().detectChanges()
  me.getHpService().emitDataChange(); 
});  
me.getChangeDetectorRef().detectChanges()
me.getHpService().emitDataChange();
});
}
/**
 * confirme Creation /Ajout un produit cas Fenetre
 */
confirmeProduct()
{
this.showProduct_visua_menu = true;
this.simulateurActive = true;
this.getHpService().setSimulateurActive(true);
let target_ = document.getElementById('target_product' + this.createProductIndex) as  HTMLInputElement
 target_.style.display = "block"
this.productsFrames[this.createProductIndex].set( "display", "block"); 
this.menuAnswersWindowsState ="in";
this.menuAnswersStepMenuState = "in";
this.createLoading = false;
this.getHpService().confirmeProduct();
this.getChangeDetectorRef().detectChanges()
this.getHpService().emitDataChange();
} 

cloneObject(i)
{
let frame = new Frame({
     display:'block',
     left: '40%',
     top: '40%',
     transform: {
       rotate: '0deg',
       scaleX: 1,
       scaleY: 1,
       matrix3d: this.productsFrames[this.currentIndex].get('transform', 'matrix3d'),
     },
     });
   this.productsFrames.push(frame);
   this.productsFrames[this.currentIndex].set('transform', 'matrix3d', this.productsFrames[this.currentIndex].get('transform', 'matrix3d'));
   this.transformCss_w.push(this.transformCss_w[this.currentIndex]);
   this.getHpService().settransformCss_w(this.transformCss_w[this.currentIndex]);
   this.product_index++;
   this.createProductIndex++;
   this.list_catalog.push(this.list_catalog[i]);
   this.getHpService().setListCatalog(this.list_catalog[i]);
   this.getHpService().cloneObject();   
   this.getChangeDetectorRef().detectChanges();
   this.getHpService().emitDataChange();
 }
 removeObject()
 {
  this.getHpService().removeProducts(this.product_index);
  this.getHpService().setShowMultiproduct(false);
  this.productsFrames.splice(this.product_index,1);
  this.transformCss_w.splice(this.product_index,1);
  this.getHpService().removeObjectTransformCss_w(this.product_index);
  this.list_catalog.splice(this.findIndexListCatalog("product",this.product_index),1);
  this.getHpService().removeCatalogLoaded(this.findIndexListCatalog("product",this.product_index));
  this.catalog_index =-1;
  this.menu_selected = -1;
  this.catalog_selected = -1;
  this.product_index = this.product_index -1;
  this.createProductIndex--;
  this.warpable_product = false;  
  this.getChangeDetectorRef().detectChanges();
  this.getHpService().emitDataChange();
 }
 findIndexListCatalog(name,id) {
  const foundCatIndex = (element) => element.navCat_index === id;
  const foundProductIndex = (element) => element.produc_index === id;
  switch(name)
  {
    case "product":
      return ( this.getHpService().getListCalogLoaded().findIndex(foundProductIndex));
    default:
      return (this.getHpService().getListCalogLoaded().findIndex(foundCatIndex));
  }
}
/*Nav vertical Catalogue  cas cas porte fenetres */
selectExpansionMenu(index_,id,slug) 
{
 let indexFound  = this.findIndexListCatalog("catalog",index_);
 this.menu_selected = index_;
 this.catalog_index = indexFound;
 this.getHpService().setCurrentProduct(slug);
 this.warpable = false;
 this.getHpService().setCatalogIndex(index_);
 if(index_ === 0)
 {
  this.showElement(0);
 }
 this.closeAllMenu();
 this.hideMoveableControler();
 this.getChangeDetectorRef().detectChanges();
 this.getHpService().emitDataChange();
} 
getHasInOrOutView()
 {
  return  this.getHpService().getHasInOrOutView();
 }

 displayInfoAnswer(keyword: string) {

  if(!this.getHpService().getConfig().herculepro.answerMenu_info)
  {
    return -1
  }
  const showed = (element) => element.code === keyword;
  return this.getHpService().getConfig().herculepro.answerMenu_info.findIndex(showed)
}


getTextInfoBulle()
{
  return this.getHpService().getConfig().herculepro.answerMenu_info[this.displayInfoAnswer(this.getcurrentQuestion().question_code)].message;
}
showDetail()
  {
    this.stateDetail = (this.stateDetail === 'in') ? 'out' : 'in';
    this.getHpService().emitDataChange();
    this.getChangeDetectorRef().detectChanges();
  }


detectChangeService()
{
  this.getChangeDetectorRef().detectChanges()
  this.getHpService().emitDataChange(); 
}
closeMenuWindows()
{

  if(!this.showProduct_visua_menu)
  {
  this.removeObject();
  this.product_index--;
  this.createLoading =false;
  this.showProduct_visua_menu = true;  
  }
  this.menuAnswersWindowsState ="in";
  this.menuAnswersStepMenuState = "in";
  this.getChangeDetectorRef().detectChanges()
  this.getHpService().emitDataChange(); 
}

/**
 * 
 * @param i selection un menu (sans réponse) cas vitrage fenetre  menu-expansion multi 
 */
selectElement(i)
{
  this.element_showed =  i;
  this.getHpService().setMenuAnswerState("in");
  this.getHpService().setMultiMenuAnswerState("in");
  this.getChangeDetectorRef().detectChanges()
  this.getHpService().emitDataChange(); 
}
showElement(i){
  let target_product = document.getElementById('target_product'+i) as HTMLInputElement;
      target_product.style.display = "block"; 
      this.warpableProduct = false;
      this.warpable= false;
      this.getChangeDetectorRef().detectChanges()
      this.getHpService().emitDataChange();
}
hiddenElement(i){
  let target_product = document.getElementById('target_product'+i) as HTMLInputElement;
  console.log(target_product)
      target_product.style.display = "none"; 
}
displayMenuImage(){
  this.warpable = false;
  this.warpable_product = false;
  this.menuBottom_active = "menu-maison";
  this.menuImage = this.menuImage ? false : true;
  this.closeAllMenu();
}

/**
 * 
 * @returns  Affichage un catalgue par default  true / false
 */
initWithoutProduct()
{
 
  if(this.getHpService().getConfig().herculepro.multiProduct && this.getHpService().getConfig().herculepro.displayDefaultProduct)
  {
    return;
  }
  this.getHpService().removeProducts(0);
  this.list_catalog.splice(this.findIndexListCatalog("product",0),1);
  this.getHpService().removeCatalogLoaded(this.findIndexListCatalog("product",0));
  this.getHpService().setCurrentProductIndex(0); 
  this.menu_selected = -1;
  
}

initDefaultProduct()
{
  if(this.getHpService().getConfig().herculepro.multiProduct)
    {
    this.catalog_index = this.getHpService().getCatalogIndex();
      this.product_element = 0;
      this.currentIndex=0;
      this.warpable_index  =0;
      this.product_index = 0;
      if(this.getHpService().getConfig().herculepro.displayDefaultProduct)
        {
          this.addObject(true,0);
        }
      this.multiGlobaldata = this.getHpService().getMultiGlobaldata();
      this.getHpService().setBooleanParam("loadCatalo",false);
      this.getHpService().setBooleanParam("isPagecatalog",false);      
      this.globalDataLength =  this.getHpService().getMultiGlobaldata().length; 
      
    }
  }
  // Preserve original property order
  originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return 0;
  }

  // Order by ascending property value
  valueAscOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return a.value.localeCompare(b.value);
  }

  // Order by descending property key
  keyDescOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return a.key > b.key ? -1 : (b.key > a.key ? 1 : 0);
  }
}
